import React, { Fragment, useState, useEffect } from "react";
import { Timestamp } from 'firebase/firestore';
import { collection, getDocs, query, orderBy, doc, getDoc, updateDoc, addDoc } from 'firebase/firestore';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from "react-router-dom";
import { format } from 'date-fns';
import "react-calendar/dist/Calendar.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Button, Dropdown, Modal } from "react-bootstrap";
import {
    subscribeMeeting,
    getSubMeetings,
    getMeetingAgendas,
    getMeetingAnnouncements,
    getMeetingUsers,
    joinMeeting,
    addMeetingUserByEmail,
    removeMeetingUser,
    getMeetingNotes,
    createMeetingNote,
    updateMeetingRecord,
    getMeetingAIDetail,
    getMeetingSpeakers,
    getMeetingSpeechAnalysis,
    getMeetingDecisions,
    updateMeeting,
    subscribeLionNotes,
    createLionNote,
} from '../../features/meeting/meetingSlice';
import { toast } from 'react-hot-toast';
import profileService from '../../features/profile/profileService';

import {
    exportMeetingSummaryPDF,
} from "./meetingupdate";
import { toDate } from "../../utils/meetingUtils";
import { db } from "../../config/firebase";


// Şablon & Tip rozetleri
const TEMPLATE_LABELS = { '0': 'STANDART', '1': 'BİREBİR', '2': 'LION', '99': 'DİĞER' };
const TYPE_LABELS = { '0': 'Fiziksel', '1': 'Online', '2': 'Hibrit', '3': 'Telefon', '4': 'Yazışma', '99': 'Diğer' };


const styles = {
    bgSuccessLight: {
        backgroundColor: 'rgba(40, 131, 167, 0.1) !important'
    },
    uploadContainer: {
        transition: 'all 0.3s ease',
        border: '2px dashed #ccc',
        borderRadius: '8px',
        padding: '1.5rem'
    },
    uploadContainerHover: {
        borderColor: '#b7c3cdff'
    },
    uploadContainerDragging: {
        borderColor: '#2072c9ff',
        backgroundColor: 'rgba(40, 120, 240, 0.1)',
        transform: 'scale(1.01)'
    },
    progressBar: {
        transition: 'width 0.5s ease'
    },
    audioPlayer: {
        width: '100%',
        marginTop: '10px'
    },
    selectedFile: {
        transition: 'all 0.2s ease'
    },
    selectedFileHover: {
        transform: 'translateY(-2px)',
        boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)!important'
    },
    summaryCard: {
        borderLeft: '4px solid #1785b8ff',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
    },
    summarySection: {
        background: '#fff',
        borderRadius: '8px',
        transition: 'all 0.2s ease'
    },
    summaryItem: {
        background: '#fff',
        borderRadius: '8px',
        padding: '15px',
        marginBottom: '10px',
        border: '1px solid #e9ecef',
        transition: 'all 0.2s ease'
    }
};

function MeetingDetail() {
    let { meetingId } = useParams();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("meetingAIDetailSummary");
    const [activeTab2, setActiveTab2] = useState("meetingTranscript");
    const [activeToggle, setActiveToggle] = useState("about");
    const { user } = useSelector((state) => state.auth);
    const isAuthenticated = useSelector((state) => state.auth.user !== null);
    const myUserId = useSelector((state) => state.auth.user.uid);
    const isPremium = Boolean(user?.premium);
    const PRICING_URL = "https://beetinq.com/#pricing";



    const meetingState = useSelector((state) => state.meeting || {});
    const {
        meetings = [],
        meetingAnnouncements = [],
        meetingUsers = [],
        meetingNotes = [],
        meetingAgendas = [],
        meetingDecisions = [],
        meetingAIDetail = {},
        meetingSpeakers = [],
        meetingSpeechAnalysis = {},
        lionNotesBySection = {
            lastWeek: [],
            issues: [],
            opportunities: [],
            nextWeek: [],
        },
        isLoading,
        isError,
        message,
        errors,
        loadingStates
    } = meetingState;
    const meeting = meetingState.meeting ?? {};
    const meetingOnlineLink =
        meeting?.urlAttendee ||
        meeting?.urlattendee ||
        meeting?.urlHost ||
        meeting?.urlhost ||
        meeting?.url ||
        '';
    const meetingBriefing = meeting?.meetingDescription || meeting?.details || '';
    const myUserProfile = meetingUsers.find((u) => (u?.uid || u?.userId || u?.id) === myUserId);
    const isPremiumFinal = Boolean(user?.premium ?? myUserProfile?.premium);

    const INEFFICIENCY_TYPE_LABELS = {
        off_topic: "Gündem Dışı",
        repetition: "Tekrar",
        unclear_communication: "Belirsiz İletişim",
        excessive_silence_or_filler: "Aşırı Sessizlik/Dolgu",
    };

    // --- Template bayrakları (effect'lerden ve render'dan ÖNCE tanımlanmalı) ---
    const tpl = String(meeting?.meetingTemplate ?? '0');
    const IS_LION = tpl === '2';
    // LION bölümleri ve etiketleri (Firestore key -> görünen başlık)
    const LION_SECTIONS = {
        lastWeek: 'Last Week',
        issues: 'Issues & Solutions',
        opportunities: 'Opportunities',
        nextWeek: 'Next Week',
    };

    // LION modal state’leri
    const [lionModalOpen, setLionModalOpen] = useState(false);
    const [lionSectionKey, setLionSectionKey] = useState(null);
    const [lionForm, setLionForm] = useState({ title: '', details: '' });
    const [lionSaving, setLionSaving] = useState(false);
    const [selectedLionUserId, setSelectedLionUserId] = useState(null);
    const [lionParticipants, setLionParticipants] = useState([]);

    const openLionModal = (sectionKey) => {
        setLionSectionKey(sectionKey);
        setLionForm({ title: '', details: '' });
        setLionModalOpen(true);
    };

    const saveLionNote = async (e) => {
        e.preventDefault();
        if (!lionSectionKey) return;

        try {
            setLionSaving(true);
            const trimmedTitle = (lionForm.title || '').trim();
            const trimmedDetails = (lionForm.details || '').trim();

            await dispatch(createLionNote({
                meetingId,
                sectionKey: lionSectionKey,
                title: trimmedTitle,
                details: trimmedDetails,
            })).unwrap();

            setLionSaving(false);
            setLionModalOpen(false);
            setLionForm({ title: '', details: '' });
            toast.success('Not başarıyla kaydedildi.');
        } catch (err) {
            setLionSaving(false);
            toast.error('Not kaydedilemedi.');
            console.error(err);
        }
    };


    const IS_BIREBIR = tpl === '1';
    const IS_STD = tpl === '0' || tpl === '99';

    const TEMPLATE_STYLES = {
        '2': { className: 'badge bg-primary', icon: 'fa-shield' }, // LION
        '1': { className: 'badge bg-success', icon: 'fa-user' }, // BİREBİR
        '0': { className: 'badge bg-secondary', icon: 'fa-circle' }, // STANDART
        '99': { className: 'badge bg-dark', icon: 'fa-ellipsis-h' } // DİĞER
    };
    const [activeLionBox, setActiveLionBox] = useState(null);

    const [seconds, setSeconds] = useState(0);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [meetingRecord, setMeetingRecord] = useState(null);
    const meetingRecordDate = toDate(meetingRecord?.updateDate);
    const [meetingRecordList, setMeetingRecordList] = useState([]);
    const [isDragging, setIsDragging] = useState(false);
    const [isDecisionEditOpen, setIsDecisionEditOpen] = useState(false);
    const [editingDecision, setEditingDecision] = useState(null);
    const [decisionEditTitle, setDecisionEditTitle] = useState('');
    const [decisionEditDetails, setDecisionEditDetails] = useState('');
    const [decisionEditDeadline, setDecisionEditDeadline] = useState('');
    const [decisionEditCompleted, setDecisionEditCompleted] = useState(false);
    const [decisionEditUsers, setDecisionEditUsers] = useState([]);
    const [isDecisionSaving, setIsDecisionSaving] = useState(false);
    const [newDecisionTitle, setNewDecisionTitle] = useState('');
    const [newDecisionDetails, setNewDecisionDetails] = useState('');
    const [newDecisionDeadline, setNewDecisionDeadline] = useState('');
    const [newDecisionUsers, setNewDecisionUsers] = useState([]);
    const [isAddingDecision, setIsAddingDecision] = useState(false);
    const [isDecisionAddOpen, setIsDecisionAddOpen] = useState(false);
    const [isAgendaAddOpen, setIsAgendaAddOpen] = useState(false);
    const [isAgendaEditOpen, setIsAgendaEditOpen] = useState(false);
    const [editingAgenda, setEditingAgenda] = useState(null);
    const [agendaTitle, setAgendaTitle] = useState('');
    const [agendaDetails, setAgendaDetails] = useState('');
    const [agendaStartTime, setAgendaStartTime] = useState('');
    const [agendaEndTime, setAgendaEndTime] = useState('');
    const [agendaUsers, setAgendaUsers] = useState([]);
    const [isAgendaSaving, setIsAgendaSaving] = useState(false);
    const [isAgendaAdding, setIsAgendaAdding] = useState(false);

    // Text Summarization States
    const [textSummary, setTextSummary] = useState(null);
    const [isSummarizing, setIsSummarizing] = useState(false);
    const [summaryError, setSummaryError] = useState(null);
    const [meetingRecordsAI, setMeetingRecordsAI] = useState([]);
    const [selectedRecordIndex, setSelectedRecordIndex] = useState(0);
    const [selectedRecordSpeakers, setSelectedRecordSpeakers] = useState([]);
    const [selectedRecordSpeechAnalysis, setSelectedRecordSpeechAnalysis] = useState(null);
    const [mergedMeetingAI, setMergedMeetingAI] = useState(null);
    const [selectedAIRecordIndex, setSelectedAIRecordIndex] = useState(0);

    const loadError = errors?.getMeeting;

    const getDecisionDateMs = (decision) => {
        const value = decision?.date ?? decision?.createDate ?? decision?.createdAt ?? decision?.complatedDate ?? null;
        if (typeof value === 'number') return value;
        if (value && typeof value === 'object' && typeof value.seconds === 'number') return value.seconds * 1000;
        const parsed = value ? new Date(value).getTime() : NaN;
        return Number.isNaN(parsed) ? 0 : parsed;
    };

    const toInputDateValue = (value) => {
        if (!value) return '';
        let dateObj = null;
        if (value instanceof Date) {
            dateObj = value;
        } else if (typeof value === 'number') {
            dateObj = new Date(value);
        } else if (value && typeof value === 'object' && typeof value.seconds === 'number') {
            dateObj = new Date(value.seconds * 1000);
        } else {
            const parsed = new Date(value);
            if (!Number.isNaN(parsed.getTime())) dateObj = parsed;
        }
        if (!dateObj || Number.isNaN(dateObj.getTime())) return '';
        return dateObj.toISOString().slice(0, 10);
    };
    const toInputTimeValue = (value) => {
        if (!value) return '';
        let d = null;
        if (value instanceof Date) d = value;
        else if (typeof value === 'number') d = new Date(value);
        else if (value && typeof value === 'object' && typeof value.seconds === 'number') d = new Date(value.seconds * 1000);
        else {
            const parsed = new Date(value);
            if (!Number.isNaN(parsed.getTime())) d = parsed;
        }
        if (!d || Number.isNaN(d.getTime())) return '';
        const hh = `${d.getHours()}`.padStart(2, '0');
        const mm = `${d.getMinutes()}`.padStart(2, '0');
        return `${hh}:${mm}`;
    };

    const sortedMeetingDecisions = [...(meetingDecisions || [])].sort((a, b) => {
        const dateDiff = getDecisionDateMs(a) - getDecisionDateMs(b);
        if (dateDiff !== 0) return dateDiff;

        const numA = Number((a?.title || '').match(/\d+/)?.[0] || 0);
        const numB = Number((b?.title || '').match(/\d+/)?.[0] || 0);
        if (numA !== numB) return numA - numB;

        return String(a?.id || '').localeCompare(String(b?.id || ''));
    });

    const resolveUserId = (user) => user?.uid || user?.userId || user?.id || '';
    const resolveUserName = (user) =>
        user?.name ||
        user?.fullName ||
        [user?.firstName, user?.lastName].filter(Boolean).join(' ') ||
        user?.userEmail ||
        'İsimsiz';
    const meetingParticipantOptions = (meetingUsers || [])
        .map((u) => ({ id: resolveUserId(u), name: resolveUserName(u) }))
        .filter((u) => Boolean(u.id));
    const findParticipantName = (userId) => {
        const found = meetingParticipantOptions.find((p) => p.id === userId);
        return found?.name || userId;
    };
    const toggleAgendaUser = (userId) => {
        if (!userId) return;
        setAgendaUsers((prev) => (prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]));
    };

    const combineAgendaTimeToTimestamp = (timeText) => {
        const base = new Date();
        const [h = '00', m = '00'] = (timeText || '').split(':');
        base.setHours(Number(h), Number(m), 0, 0);
        return Timestamp.fromDate(base);
    };

    const openAgendaAddModal = () => {
        setEditingAgenda(null);
        setAgendaTitle('');
        setAgendaDetails('');
        setAgendaStartTime('');
        setAgendaEndTime('');
        setAgendaUsers([]);
        setIsAgendaAddOpen(true);
    };

    const openAgendaEditModal = (agenda) => {
        setEditingAgenda(agenda);
        setAgendaTitle(agenda?.title || '');
        setAgendaDetails(agenda?.details || '');
        setAgendaStartTime(toInputTimeValue(agenda?.startTime));
        setAgendaEndTime(toInputTimeValue(agenda?.endTime));
        setAgendaUsers(Array.isArray(agenda?.users) ? agenda.users : []);
        setIsAgendaEditOpen(true);
    };

    const handleAgendaAdd = async (e) => {
        e.preventDefault();
        const trimmedTitle = agendaTitle.trim();
        const trimmedDetails = agendaDetails.trim();
        if (!trimmedTitle || !trimmedDetails || !agendaStartTime || !agendaEndTime) {
            toast.error('Başlık, detay, başlangıç ve bitiş saatleri zorunludur.');
            return;
        }
        try {
            setIsAgendaAdding(true);
            const docRef = await addDoc(collection(db, 'meetings', meetingId, 'agenda'), {
                meetingId,
                agendaId: '',
                userId: myUserId || '',
                startTime: combineAgendaTimeToTimestamp(agendaStartTime),
                endTime: combineAgendaTimeToTimestamp(agendaEndTime),
                details: trimmedDetails,
                title: trimmedTitle,
                files: [],
                users: agendaUsers,
                status: true,
                state: true,
            });
            await updateDoc(doc(db, 'meetings', meetingId, 'agenda', docRef.id), { agendaId: docRef.id });
            await dispatch(getMeetingAgendas(meetingId)).unwrap();
            setIsAgendaAddOpen(false);
            toast.success('Gündem eklendi.');
        } catch (error) {
            console.error(error);
            toast.error('Gündem eklenemedi.');
        } finally {
            setIsAgendaAdding(false);
        }
    };

    const handleAgendaUpdate = async (e) => {
        e.preventDefault();
        if (!editingAgenda?.id) return;
        const trimmedTitle = agendaTitle.trim();
        const trimmedDetails = agendaDetails.trim();
        if (!trimmedTitle || !trimmedDetails || !agendaStartTime || !agendaEndTime) {
            toast.error('Başlık, detay, başlangıç ve bitiş saatleri zorunludur.');
            return;
        }
        try {
            setIsAgendaSaving(true);
            await updateDoc(doc(db, 'meetings', meetingId, 'agenda', editingAgenda.id), {
                title: trimmedTitle,
                details: trimmedDetails,
                startTime: combineAgendaTimeToTimestamp(agendaStartTime),
                endTime: combineAgendaTimeToTimestamp(agendaEndTime),
                users: agendaUsers,
                updateDate: Timestamp.fromDate(new Date()),
            });
            await dispatch(getMeetingAgendas(meetingId)).unwrap();
            setIsAgendaEditOpen(false);
            setEditingAgenda(null);
            toast.success('Gündem güncellendi.');
        } catch (error) {
            console.error(error);
            toast.error('Gündem güncellenemedi.');
        } finally {
            setIsAgendaSaving(false);
        }
    };

    const toggleSelectedUser = (userId, isEdit) => {
        if (!userId) return;
        const setter = isEdit ? setDecisionEditUsers : setNewDecisionUsers;
        setter((prev) => (prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]));
    };

    const openDecisionEditModal = (decision) => {
        setEditingDecision(decision);
        setDecisionEditTitle(decision?.title || '');
        setDecisionEditDetails(decision?.details || '');
        setDecisionEditDeadline(toInputDateValue(decision?.deadLine));
        setDecisionEditCompleted(Boolean(decision?.isComplate));
        setDecisionEditUsers(Array.isArray(decision?.users) ? decision.users : []);
        setIsDecisionEditOpen(true);
    };

    const getNextDecisionTitle = () => {
        const maxIndex = sortedMeetingDecisions.reduce((acc, item) => {
            const n = Number((item?.title || '').match(/\d+/)?.[0] || 0);
            return Math.max(acc, n);
        }, 0);
        return `Karar ${maxIndex + 1}`;
    };

    const handleAddDecision = async (e) => {
        e.preventDefault();
        const trimmedDetails = newDecisionDetails.trim();
        const trimmedTitle = (newDecisionTitle || '').trim() || getNextDecisionTitle();
        if (!trimmedDetails) {
            toast.error('Karar detayı boş bırakılamaz.');
            return;
        }

        try {
            setIsAddingDecision(true);
            const now = Timestamp.fromDate(new Date());
            const docRef = await addDoc(collection(db, 'meetings', meetingId, 'decision'), {
                meetingId,
                decisionId: '',
                userId: myUserId || 'web',
                users: newDecisionUsers,
                title: trimmedTitle,
                details: trimmedDetails,
                isComplate: false,
                complatedDate: now,
                deadLine: newDecisionDeadline ? Timestamp.fromDate(new Date(`${newDecisionDeadline}T00:00:00`)) : now,
                date: now,
                files: [],
                status: true,
                state: true,
            });

            await updateDoc(doc(db, 'meetings', meetingId, 'decision', docRef.id), {
                decisionId: docRef.id,
            });

            await dispatch(getMeetingDecisions(meetingId)).unwrap();
            setNewDecisionTitle('');
            setNewDecisionDetails('');
            setNewDecisionDeadline('');
            setNewDecisionUsers([]);
            setIsDecisionAddOpen(false);
            toast.success('Karar eklendi.');
        } catch (error) {
            console.error(error);
            toast.error('Karar eklenemedi.');
        } finally {
            setIsAddingDecision(false);
        }
    };

    const handleDecisionUpdate = async (e) => {
        e.preventDefault();
        if (!editingDecision?.id) return;

        const trimmedTitle = decisionEditTitle.trim();
        const trimmedDetails = decisionEditDetails.trim();
        if (!trimmedTitle || !trimmedDetails) {
            toast.error('Başlık ve detay boş bırakılamaz.');
            return;
        }

        try {
            setIsDecisionSaving(true);
            await updateDoc(doc(db, 'meetings', meetingId, 'decision', editingDecision.id), {
                title: trimmedTitle,
                details: trimmedDetails,
                deadLine: decisionEditDeadline
                    ? Timestamp.fromDate(new Date(`${decisionEditDeadline}T00:00:00`))
                    : null,
                isComplate: decisionEditCompleted,
                users: decisionEditUsers,
                complatedDate: decisionEditCompleted
                    ? Timestamp.fromDate(new Date())
                    : (editingDecision?.complatedDate ?? Timestamp.fromDate(new Date())),
                updateDate: Timestamp.fromDate(new Date()),
            });
            await dispatch(getMeetingDecisions(meetingId)).unwrap();
            toast.success('Karar güncellendi.');
            setIsDecisionEditOpen(false);
            setEditingDecision(null);
        } catch (error) {
            console.error(error);
            toast.error('Karar güncellenemedi.');
        } finally {
            setIsDecisionSaving(false);
        }
    };

    const toggleDecisionCompletion = async (decision) => {
        if (!decision?.id) return;
        const nextCompleted = !Boolean(decision?.isComplate);
        try {
            await updateDoc(doc(db, 'meetings', meetingId, 'decision', decision.id), {
                isComplate: nextCompleted,
                complatedDate: nextCompleted
                    ? Timestamp.fromDate(new Date())
                    : (decision?.complatedDate ?? Timestamp.fromDate(new Date())),
                updateDate: Timestamp.fromDate(new Date()),
            });
            await dispatch(getMeetingDecisions(meetingId)).unwrap();
            toast.success(nextCompleted ? 'Karar tamamlandı olarak işaretlendi.' : 'Karar devam ediyor durumuna alındı.');
        } catch (error) {
            console.error(error);
            toast.error('Durum güncellenemedi.');
        }
    };

    useEffect(() => {
        if (!isAuthenticated) { navigate('/login') }
        if (loadError) { toast.error(loadError || message); }
        const meetingSub = dispatch(subscribeMeeting(meetingId))
        dispatch(getMeetingUsers(meetingId))
        dispatch(getMeetingAgendas(meetingId))
        dispatch(getMeetingDecisions(meetingId))
        dispatch(getMeetingNotes(meetingId))
        dispatch(getMeetingAIDetail(meetingId))
        dispatch(getMeetingSpeakers(meetingId))
        dispatch(getMeetingSpeechAnalysis(meetingId))





        /*
        const interval = setInterval(() => {
            setSeconds(seconds => seconds + 1);
        }, 30000);
        */

        // return () => { if (isAuthenticated) { dispatch(reset()) } }
        //}, [isAuthenticated, navigate, isError, message, dispatch])
        return () => {
            meetingSub.then((action) => {
                const unsubscribe = action?.payload;
                if (typeof unsubscribe === 'function') unsubscribe();
            });
        };
    }, [isAuthenticated, navigate, seconds, loadError, message, dispatch, meetingId])

    // Toplantı verisi yüklendiğinde, ses kaydı bilgisini kontrol et
    useEffect(() => {
        if (meeting && (meeting.recordingUrl || meeting.meetingrecordurl)) {
            setMeetingRecord({
                url: meeting.recordingUrl || meeting.meetingrecordurl,
                name: meeting.recordingName || "Toplantı Ses Kaydı",
                updateDate: meeting.recordingUpdateDate || null
            });
        }
    }, [meeting]);

    useEffect(() => {
        const loadMeetingAssemblyRecords = async () => {
            try {
                const colRef = collection(db, 'meetings', meetingId, 'assemblyAI');
                let snapshot;
                try {
                    snapshot = await getDocs(query(colRef, orderBy('timestamp', 'asc')));
                } catch (e) {
                    snapshot = await getDocs(colRef);
                }

                const toMs = (value) => {
                    if (!value) return 0;
                    if (typeof value?.toDate === 'function') return value.toDate().getTime();
                    if (typeof value?.seconds === 'number') return value.seconds * 1000;
                    if (typeof value === 'number') return value < 1e12 ? value * 1000 : value;
                    const dateMs = new Date(value).getTime();
                    return Number.isNaN(dateMs) ? 0 : dateMs;
                };

                const records = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
                records.sort((a, b) => {
                    const aMs = toMs(a.timestamp || a.updateDate || a.createdAt || a.geminiUpdatedAt);
                    const bMs = toMs(b.timestamp || b.updateDate || b.createdAt || b.geminiUpdatedAt);
                    return aMs - bMs;
                });

                setMeetingRecordsAI(records);
                setSelectedRecordIndex(0);
            } catch (error) {
                console.error('meeting assembly records load error:', error);
                setMeetingRecordsAI([]);
                setSelectedRecordSpeakers([]);
                setSelectedRecordIndex(0);
            }
        };

        const loadMergedMeetingAI = async () => {
            try {
                const mergedDocRef = doc(db, 'meetings', meetingId, 'analysis_merged', 'current');
                const mergedSnap = await getDoc(mergedDocRef);
                if (mergedSnap.exists()) {
                    setMergedMeetingAI({ id: 'merged-current', ...mergedSnap.data(), isMerged: true });
                } else {
                    setMergedMeetingAI(null);
                }
            } catch (error) {
                console.error('merged meeting ai load error:', error);
                setMergedMeetingAI(null);
            }
        };

        if (meetingId) {
            loadMeetingAssemblyRecords();
            loadMergedMeetingAI();
        }
    }, [meetingId, seconds]);

    useEffect(() => {
        const loadMeetingRecords = async () => {
            try {
                const recordsColRef = collection(db, 'meetings', meetingId, 'records');
                let snap;
                try {
                    snap = await getDocs(query(recordsColRef, orderBy('updateDate', 'desc')));
                } catch (e) {
                    snap = await getDocs(recordsColRef);
                }
                const records = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
                setMeetingRecordList(records);
            } catch (error) {
                console.error('meeting records load error:', error);
                setMeetingRecordList([]);
            }
        };

        if (meetingId) {
            loadMeetingRecords();
        }
    }, [meetingId, seconds]);

    useEffect(() => {
        const loadSelectedRecordSpeakers = async () => {
            const selectedRecord = meetingRecordsAI[selectedRecordIndex];
            if (!selectedRecord?.id) {
                setSelectedRecordSpeakers([]);
                return;
            }
            try {
                const speakersColRef = collection(db, 'meetings', meetingId, 'assemblyAI', selectedRecord.id, 'speakers');
                const speakersSnap = await getDocs(query(speakersColRef, orderBy('start', 'asc')));
                const speakers = speakersSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
                setSelectedRecordSpeakers(speakers);
            } catch (error) {
                console.error('selected record speakers load error:', error);
                setSelectedRecordSpeakers([]);
            }
        };

        loadSelectedRecordSpeakers();
    }, [meetingId, meetingRecordsAI, selectedRecordIndex]);

    const selectedRecord = meetingRecordsAI[selectedRecordIndex];
    const transcriptText = selectedRecord?.transcript || meeting.meetingTranscripts || "";
    const transcriptSpeakers = selectedRecordSpeakers.length > 0 ? selectedRecordSpeakers : meetingSpeakers;
    const aiRecordsForDisplay = mergedMeetingAI ? [mergedMeetingAI, ...meetingRecordsAI] : meetingRecordsAI;
    const selectedAIRecord = aiRecordsForDisplay[selectedAIRecordIndex];
    const selectedMeetingAIDetail = selectedAIRecord || selectedRecord || meetingAIDetail;
    const selectedMeetingSpeechAnalysis = selectedAIRecord?.isMerged
        ? null
        : (selectedRecordSpeechAnalysis || meetingSpeechAnalysis);

    useEffect(() => {
        setSelectedAIRecordIndex(0);
    }, [mergedMeetingAI, meetingRecordsAI.length]);

    useEffect(() => {
        const loadSelectedRecordSpeechAnalysis = async () => {
            const selected = aiRecordsForDisplay[selectedAIRecordIndex];
            if (selected?.isMerged) {
                setSelectedRecordSpeechAnalysis(null);
                return;
            }
            if (!selected?.id) {
                setSelectedRecordSpeechAnalysis(null);
                return;
            }
            try {
                const analysisColRef = collection(db, 'meetings', meetingId, 'assemblyAI', selected.id, 'speech_analysis');
                const analysisSnap = await getDocs(analysisColRef);
                const list = analysisSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
                setSelectedRecordSpeechAnalysis(list[0] || null);
            } catch (error) {
                console.error('selected record speech analysis load error:', error);
                setSelectedRecordSpeechAnalysis(null);
            }
        };

        loadSelectedRecordSpeechAnalysis();
    }, [meetingId, aiRecordsForDisplay, selectedAIRecordIndex]);

    const onMeetingJoin = e => {
        //e.prmeetingDefault();
        dispatch(joinMeeting(meetingId))
        setSeconds(seconds => seconds + 1);
    }

    const getDefaultTab = () => {
        if (IS_LION) return 'lion';
        if (IS_BIREBIR) return 'notes';
        return 'about';
    };

    const getAvailableTabs = () => {
        const tabs = ['about'];
        if (IS_LION) tabs.push('lion');
        if (!IS_LION) tabs.push('notes');
        if (!IS_LION && !IS_BIREBIR && isPremiumFinal) {
            tabs.push('agenda');
            tabs.push('decision');
        }
        if (!IS_BIREBIR) tabs.push('participants');
        if (!IS_LION && isPremiumFinal) tabs.push('record');
        if (meeting?.isTranscribed && !IS_BIREBIR) {
            tabs.push('transcript');
            tabs.push('meetingAI');
        }
        return tabs;
    };

    const setTabAndUrl = (tabKey, replace = false) => {
        setActiveToggle(tabKey);
        const next = new URLSearchParams(searchParams);
        if (next.get('tab') !== tabKey) {
            next.set('tab', tabKey);
            setSearchParams(next, { replace });
        }
    };

    useEffect(() => {
        if (!meeting) return;
        const availableTabs = getAvailableTabs();
        const tabFromUrl = searchParams.get('tab');
        const resolvedTab = availableTabs.includes(tabFromUrl) ? tabFromUrl : getDefaultTab();
        if (activeToggle !== resolvedTab) {
            setActiveToggle(resolvedTab);
        }
        if (tabFromUrl !== resolvedTab) {
            const next = new URLSearchParams(searchParams);
            next.set('tab', resolvedTab);
            setSearchParams(next, { replace: true });
        }
    }, [meeting, IS_LION, IS_BIREBIR, isPremiumFinal, meeting?.isTranscribed, searchParams, setSearchParams, activeToggle]);

    const [noteTitle, setNoteTitle] = useState('')
    const [noteContext, setNoteContext] = useState('')
    const [isNoteEditOpen, setIsNoteEditOpen] = useState(false);
    const [editingNote, setEditingNote] = useState(null);
    const [noteEditTitle, setNoteEditTitle] = useState('');
    const [noteEditContext, setNoteEditContext] = useState('');
    const [isNoteSaving, setIsNoteSaving] = useState(false);
    const [isAboutEditOpen, setIsAboutEditOpen] = useState(false);
    const [aboutOnlineLink, setAboutOnlineLink] = useState('');
    const [isAboutSaving, setIsAboutSaving] = useState(false);
    const [participantEmail, setParticipantEmail] = useState('');
    const [participantInviteError, setParticipantInviteError] = useState('');
    const [isAddingParticipant, setIsAddingParticipant] = useState(false);
    const [removingParticipantId, setRemovingParticipantId] = useState('');
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [isSavingEdit, setIsSavingEdit] = useState(false);
    const [isCancellingMeeting, setIsCancellingMeeting] = useState(false);
    const [isDeletingMeeting, setIsDeletingMeeting] = useState(false);
    const [editForm, setEditForm] = useState({
        title: '',
        meetingDescription: '',
        startDate: '',
        endDate: '',
        urlAttendee: '',
    });

    const meetingNoteData = {
        title: noteTitle,
        context: noteContext,
        messageDate: Timestamp.fromDate(new Date()),
        files: [],
        meetingId: meetingId,
        state: true,
        status: true,
        type: "1",
        noteId: "",
    };
    useEffect(() => {
        if (!meetingId || !IS_LION) return;

        const promise = dispatch(subscribeLionNotes(meetingId));
        return () => {
            promise.then((action) => {
                const unsubscribe = action?.payload;
                if (typeof unsubscribe === 'function') unsubscribe();
            });
        };
    }, [dispatch, meetingId, IS_LION]);

    useEffect(() => {
        if (!Array.isArray(lionParticipants)) return;
        setSelectedLionUserId(null);
    }, [lionParticipants]);

    useEffect(() => {
        const users = Array.isArray(meeting?.users) ? meeting.users : [];
        if (!users.length) {
            setLionParticipants([]);
            return;
        }

        let isActive = true;
        const ids = users.map((u) => (typeof u === 'string' ? u : u?.uid || u?.userId || u?.id)).filter(Boolean);

        Promise.all(
            ids.map((id) =>
                profileService.getProfile(id).catch(() => null)
            )
        ).then((profiles) => {
            if (!isActive) return;
            const merged = ids.map((id, idx) => {
                const profile = profiles[idx];
                return profile ? { ...profile, id: profile.id || id, uid: profile.uid || id, userId: profile.userId || id } : { id, uid: id, userId: id };
            });
            setLionParticipants(merged);
        });

        return () => {
            isActive = false;
        };
    }, [meeting?.users]);

    const toggleLionUser = (userId) => {
        setSelectedLionUserId((prev) => (prev === userId ? null : userId));
    };

    const getLionUserLabel = (userId) => {
        const user =
            lionParticipants.find((u) => (u?.uid || u?.userId || u?.id) === userId) ||
            meetingUsers.find((u) => (u?.uid || u?.userId || u?.id) === userId);
        if (!user) return 'Bilinmeyen';
        const fullName = [user?.name, user?.surName].filter(Boolean).join(' ');
        return fullName || user?.userEmail || userId?.slice?.(0, 8) || 'Bilinmeyen';
    };

    const filterLionNotes = (notes) => {
        if (!Array.isArray(notes)) return [];
        if (!selectedLionUserId) return [];
        return notes.filter((note) => note.userId === selectedLionUserId);
    };

    const handlePremiumGate = (e) => {
        e.preventDefault();
        window.open(PRICING_URL, "_blank", "noopener,noreferrer");
    };

    const renderPremiumUpsell = (featureName) => (
        <div className="p-4 bg-white rounded border">
            <h4 className="text-info mb-2">{featureName} (Premium)</h4>
            <p className="text-muted mb-3">
                Bu özellik yalnızca Premium hesaplarda kullanılabilir.
            </p>
            <button className="btn btn-warning" onClick={handlePremiumGate}>
                ★ Fiyatlandırmayı Gör
            </button>
        </div>
    );

    // Not ekleme (diğer not sistemi için)
    const onSubmitNote = (e) => {
        e.preventDefault();

        if (noteTitle !== '' || noteContext !== '') {
            dispatch(createMeetingNote(meetingNoteData));
            setNoteTitle('');
            setNoteContext('');
        }
    };

    const openNoteEditModal = (note) => {
        setEditingNote(note);
        setNoteEditTitle(note?.title || '');
        setNoteEditContext(note?.context || '');
        setIsNoteEditOpen(true);
    };

    const handleNoteUpdate = async (e) => {
        e.preventDefault();
        const noteDocId = editingNote?.id || editingNote?.noteId;
        if (!noteDocId) return;
        if (!noteEditTitle.trim() || !noteEditContext.trim()) {
            toast.error('Başlık ve detay zorunludur.');
            return;
        }
        try {
            setIsNoteSaving(true);
            await updateDoc(doc(db, 'meetings', meetingId, 'notes', noteDocId), {
                title: noteEditTitle.trim(),
                context: noteEditContext.trim(),
                updateDate: Timestamp.fromDate(new Date()),
            });
            await dispatch(getMeetingNotes(meetingId)).unwrap();
            setIsNoteEditOpen(false);
            setEditingNote(null);
            toast.success('Not güncellendi.');
        } catch (error) {
            console.error(error);
            toast.error('Not güncellenemedi.');
        } finally {
            setIsNoteSaving(false);
        }
    };

    const onAddParticipantByEmail = async (e) => {
        e.preventDefault();
        setParticipantInviteError('');

        const trimmedEmail = (participantEmail || '').trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(trimmedEmail)) {
            setParticipantInviteError('Lütfen geçerli bir e-posta adresi girin.');
            return;
        }

        try {
            setIsAddingParticipant(true);
            await dispatch(addMeetingUserByEmail({ meetingId, email: trimmedEmail })).unwrap();
            await dispatch(getMeetingUsers(meetingId));
            setParticipantEmail('');
            toast.success('Katılımcı toplantıya eklendi.');
        } catch (error) {
            if (error === 'USER_NOT_FOUND') {
                setParticipantInviteError('Kullanıcı bulunamadı. Toplantı linkini katılımcılar ile paylaşarak toplantıya katılmasını sağlayabilirsiniz.');
            } else {
                setParticipantInviteError(error || 'Katılımcı eklenirken bir hata oluştu.');
            }
        } finally {
            setIsAddingParticipant(false);
        }
    };

    const openAboutEditModal = () => {
        setAboutOnlineLink(meetingOnlineLink || '');
        setIsAboutEditOpen(true);
    };

    const handleAboutUpdate = async (e) => {
        e.preventDefault();
        const trimmed = (aboutOnlineLink || '').trim();
        if (trimmed && !/^https?:\/\//i.test(trimmed)) {
            toast.error('Link http:// veya https:// ile başlamalı.');
            return;
        }
        try {
            setIsAboutSaving(true);
            await dispatch(updateMeeting({
                id: meetingId,
                meetingData: {
                    urlAttendee: trimmed,
                    urlattendee: trimmed,
                    url: trimmed,
                }
            })).unwrap();
            setIsAboutEditOpen(false);
            toast.success('Online toplantı linki güncellendi.');
        } catch (error) {
            console.error(error);
            toast.error('Link güncellenemedi.');
        } finally {
            setIsAboutSaving(false);
        }
    };

    const onRemoveParticipant = async (participantUserId) => {
        if (!participantUserId || participantUserId === myUserId) return;

        try {
            setRemovingParticipantId(participantUserId);
            await dispatch(removeMeetingUser({ meetingId, userId: participantUserId })).unwrap();
            await dispatch(getMeetingUsers(meetingId));
            toast.success('Katılımcı toplantıdan çıkarıldı.');
        } catch (error) {
            toast.error(error || 'Katılımcı çıkarılırken bir hata oluştu.');
        } finally {
            setRemovingParticipantId('');
        }
    };

    const validateAudioFiles = (fileList) => {
        const files = Array.from(fileList || []);
        if (!files.length) return [];

        const maxSize = 250 * 1024 * 1024; // 250MB
        const supportedTypes = ['audio/mpeg', 'audio/wav', 'audio/mp4', 'audio/aac', 'audio/ogg'];
        const validExtensions = ['mp3', 'wav', 'm4a', 'aac', 'ogg', 'mp4'];
        const validFiles = [];

        files.forEach((file) => {
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (file.size > maxSize) {
                toast.error(`${file.name}: Dosya boyutu 250MB'dan büyük.`);
                return;
            }

            if (!supportedTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
                toast.error(`${file.name}: Desteklenmeyen dosya formatı.`);
                return;
            }

            validFiles.push(file);
        });

        return validFiles;
    };

    const handleFileChange = (e) => {
        const validFiles = validateAudioFiles(e.target.files);
        if (!validFiles.length) {
            e.target.value = '';
            return;
        }

        setSelectedFiles((prev) => [...prev, ...validFiles]);
        toast.success(`${validFiles.length} dosya seçildi. Yüklemek için "Kayıt Yükle" butonuna tıklayın.`);
        e.target.value = '';
    };

    const handleRecordSubmit = async (e) => {
        e.preventDefault();
        if (!selectedFiles.length) {
            toast.error('Lütfen en az bir ses dosyası seçin.');
            return;
        }

        try {
            setIsUploading(true);
            toast.loading('Ses kayıtları yükleniyor...', { id: 'audioUpload' });

            // Kullanıcıya sayfadan ayrılmamasını hatırlatalım
            window.onbeforeunload = () => {
                return "Dosya yükleme işlemi devam ediyor. Sayfadan ayrılırsanız yükleme iptal edilecektir.";
            };

            let lastResult = null;
            for (let i = 0; i < selectedFiles.length; i++) {
                const file = selectedFiles[i];
                const meetingData = { recordFile: file };
                const start = i / selectedFiles.length;
                const span = 1 / selectedFiles.length;

                const result = await dispatch(updateMeetingRecord({
                    meetingData,
                    id: meeting.id,
                    onProgress: (progress) => {
                        const normalized = Math.min(100, Math.max(0, progress));
                        const totalProgress = Math.round((start + (normalized / 100) * span) * 100);
                        setUploadProgress(totalProgress);
                    }
                })).unwrap();
                lastResult = result;
            }

            if (lastResult) {
                setMeetingRecord({
                    url: lastResult.recordingUrl,
                    name: lastResult.recordingName,
                    updateDate: lastResult.recordingUpdateDate
                });
            }

            // Reset form state
            setIsUploading(false);
            setSelectedFiles([]);
            setUploadProgress(0);

            // Sayfa ayrılma uyarısını kaldıralım
            window.onbeforeunload = null;

            toast.success(`${selectedFiles.length} ses dosyası başarıyla yüklendi!`, { id: 'audioUpload' });
        } catch (error) {
            console.error("Upload error:", error);
            setIsUploading(false);
            setUploadProgress(0);

            // Sayfa ayrılma uyarısını kaldıralım
            window.onbeforeunload = null;

            // Daha açıklayıcı hata mesajları ekleyelim
            let errorMessage = 'Bilinmeyen bir hata oluştu';

            if (error.message) {
                if (error.message.includes('storage/unauthorized')) {
                    errorMessage = 'Ses kaydı yükleme izniniz bulunmuyor. Lütfen yöneticinizle iletişime geçin.';
                } else if (error.message.includes('storage/quota-exceeded')) {
                    errorMessage = 'Depolama limitinize ulaştınız. Lütfen yöneticinizle iletişime geçin.';
                } else if (error.message.includes('storage/canceled')) {
                    errorMessage = 'Yükleme iptal edildi.';
                } else if (error.message.includes('storage/unknown')) {
                    errorMessage = 'Sunucu bağlantısında bir sorun oluştu. Lütfen internet bağlantınızı kontrol edin.';
                } else {
                    errorMessage = `Yükleme sırasında bir hata oluştu: ${error.message}`;
                }
            }

            toast.error(errorMessage, { id: 'audioUpload' });
        }
    };

    const formatStartEndDate = (startDate, endDate) => {
        const startDateObj = toDate(startDate);
        const endDateObj = toDate(endDate);
        if (!startDateObj || !endDateObj) return '';
        return format(startDateObj, "dd MMM yyyy HH:mm") + " - " + format(endDateObj, "HH:mm");
    };

    // Drag and drop handlers
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);

        if (e.dataTransfer.files?.length) {
            const validFiles = validateAudioFiles(e.dataTransfer.files);
            if (!validFiles.length) return;

            setSelectedFiles((prev) => [...prev, ...validFiles]);
            toast.success(`${validFiles.length} dosya eklendi. Yüklemek için "Kayıt Yükle" butonuna tıklayın.`);
        }
    };

    const getFormattedTimeFromMillis = (millis) => {
        try {
            const firestoreTimestamp = Timestamp.fromMillis(millis);
            const date = firestoreTimestamp.toDate();
            const time = date.toLocaleTimeString('tr-TR', {
                hour: '2-digit',
                minute: '2-digit',
            });
            return time;
        } catch (error) {
            console.error("Geçersiz zaman değeri:", error);
            return "";
        }
    };

    function formatToMinutesAndSeconds(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    }

    const openEditMeetingModal = () => {
        navigate(`/MeetingAdd?editMeetingId=${meetingId}`);
    };

    const canCancelMeeting = (() => {
        const isAdmin = Array.isArray(meeting?.adminUsers) && meeting.adminUsers.includes(myUserId);
        const startDateObj = toDate(meeting?.startDate);
        const notStarted = startDateObj instanceof Date && startDateObj.getTime() > Date.now();
        const activeStatus = String(meeting?.status ?? '0') === '0';
        return isAdmin && activeStatus && notStarted;
    })();
    const isMeetingAdmin = Array.isArray(meeting?.adminUsers) && meeting.adminUsers.includes(myUserId);

    const onCancelMeeting = async () => {
        const approved = window.confirm('Toplantıyı iptal etmek istediğinize emin misiniz?');
        if (!approved) return;

        try {
            setIsCancellingMeeting(true);
            await dispatch(updateMeeting({
                id: meetingId,
                meetingData: { status: "1" },
            })).unwrap();
            toast.success('Toplantı iptal edildi.');
        } catch (error) {
            toast.error(error || 'Toplantı iptal edilirken bir hata oluştu.');
        } finally {
            setIsCancellingMeeting(false);
        }
    };

    const onDeleteMeeting = async () => {
        const approved = window.confirm('Toplantıyı silmek istediğinize emin misiniz?');
        if (!approved) return;

        try {
            setIsDeletingMeeting(true);
            await dispatch(updateMeeting({
                id: meetingId,
                meetingData: { state: false },
            })).unwrap();
            toast.success('Toplantı silindi.');
            navigate('/allmeetings');
        } catch (error) {
            toast.error(error || 'Toplantı silinirken bir hata oluştu.');
        } finally {
            setIsDeletingMeeting(false);
        }
    };

    const onSaveMeetingEdit = async (e) => {
        e.preventDefault();
        if (!editForm.title.trim()) {
            toast.error('Toplantı başlığı zorunludur.');
            return;
        }
        if (!editForm.startDate || !editForm.endDate) {
            toast.error('Başlangıç ve bitiş tarihi zorunludur.');
            return;
        }

        const startDate = new Date(editForm.startDate);
        const endDate = new Date(editForm.endDate);
        if (endDate < startDate) {
            toast.error('Bitiş tarihi başlangıçtan önce olamaz.');
            return;
        }

        try {
            setIsSavingEdit(true);
            await dispatch(updateMeeting({
                id: meetingId,
                meetingData: {
                    title: editForm.title.trim(),
                    meetingDescription: editForm.meetingDescription.trim(),
                    startDate: Timestamp.fromDate(startDate),
                    endDate: Timestamp.fromDate(endDate),
                    urlAttendee: (editForm.urlAttendee || '').trim(),
                },
            })).unwrap();
            setEditModalOpen(false);
            toast.success('Toplantı güncellendi.');
        } catch (error) {
            toast.error(error || 'Toplantı güncellenirken bir hata oluştu.');
        } finally {
            setIsSavingEdit(false);
        }
    };

    const hasMeetingData = meeting && typeof meeting === 'object' && Object.keys(meeting).length > 0;
    const isMeetingHidden = hasMeetingData && (meeting?.state === false || meeting?.state === 'false');

    if (isMeetingHidden) {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <h3>Sayfa Bulunamadı</h3>
                            <p className="text-muted mb-4">Bu toplantı artık görüntülenemiyor.</p>
                            <Button variant="primary" onClick={() => navigate('/allmeetings')}>
                                Toplantılara Dön
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-lg-12">
                    <div className="profile card card-body px-3 pt-3 pb-0">
                        <div className="profile-head">

                            <div className="profile-info">

                                <div className="profile-details">
                                    <div className="profile-name px-3 pt-2">
                                        <h4 className="text-info mb-0">{meeting.title}</h4>
                                        <p>
                                            Katılımcı Sayısı:  {meeting.users?.length}
                                            <br />
                                            Tarih Saat: {formatStartEndDate(meeting.startDate, meeting.endDate)}
                                        </p>
                                    </div>

                                    <div className="ms-auto d-none d-sm-flex align-items-start">
                                        <Dropdown align="end">
                                            <Dropdown.Toggle
                                                variant=""
                                                id="meeting-actions-menu"
                                                className="border-0 text-white"
                                                style={{ backgroundColor: '#3B82F6', borderRadius: 8, width: 40, height: 40, padding: 0 }}
                                            >
                                                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ minWidth: 220, borderRadius: 12 }}>
                                                {!IS_LION && (
                                                    <Dropdown.Item onClick={() => setTabAndUrl("about")}>
                                                        <i className="fa fa-info-circle me-2 text-success" aria-hidden="true"></i>
                                                        Hakkında
                                                    </Dropdown.Item>
                                                )}
                                                {isMeetingAdmin && (
                                                    <Dropdown.Item onClick={openEditMeetingModal}>
                                                        <i className="fa fa-pencil me-2 text-success" aria-hidden="true"></i>
                                                        Düzenle
                                                    </Dropdown.Item>
                                                )}
                                                {isMeetingAdmin && (
                                                    <Dropdown.Item onClick={onCancelMeeting} disabled={isCancellingMeeting}>
                                                        <i className="fa fa-ban me-2" style={{ color: '#f59e0b' }} aria-hidden="true"></i>
                                                        İptal
                                                    </Dropdown.Item>
                                                )}
                                                {isMeetingAdmin && (
                                                    <Dropdown.Item onClick={onDeleteMeeting} disabled={isDeletingMeeting}>
                                                        <i className="fa fa-trash me-2 text-danger" aria-hidden="true"></i>
                                                        Sil
                                                    </Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">

                <div className="col-xl-4">
                    <div className="row">

                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    {!meeting.users?.includes(myUserId) ? (
                                        <>
                                            <a onClick={() => onMeetingJoin()} >
                                                <div className="media">
                                                    <span className="me-3">
                                                        <i className="fa fa-check"></i>
                                                    </span>
                                                    <div className="media-body">
                                                        <h4 className="">1- Toplantıya Katıl</h4>
                                                    </div>
                                                </div>

                                                <Modal show={editModalOpen} onHide={() => setEditModalOpen(false)} centered>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Toplantı Düzenle</Modal.Title>
                                                    </Modal.Header>
                                                    <form onSubmit={onSaveMeetingEdit}>
                                                        <Modal.Body>
                                                            <div className="mb-3">
                                                                <label className="form-label">Başlık</label>
                                                                <input
                                                                    className="form-control"
                                                                    value={editForm.title}
                                                                    onChange={(e) => setEditForm((prev) => ({ ...prev, title: e.target.value }))}
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Açıklama</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    rows={4}
                                                                    value={editForm.meetingDescription}
                                                                    onChange={(e) => setEditForm((prev) => ({ ...prev, meetingDescription: e.target.value }))}
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Başlangıç</label>
                                                                <input
                                                                    type="datetime-local"
                                                                    className="form-control"
                                                                    value={editForm.startDate}
                                                                    onChange={(e) => setEditForm((prev) => ({ ...prev, startDate: e.target.value }))}
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label">Bitiş</label>
                                                                <input
                                                                    type="datetime-local"
                                                                    className="form-control"
                                                                    value={editForm.endDate}
                                                                    onChange={(e) => setEditForm((prev) => ({ ...prev, endDate: e.target.value }))}
                                                                />
                                                            </div>
                                                            <div className="mb-0">
                                                                <label className="form-label">Toplantı Linki</label>
                                                                <input
                                                                    className="form-control"
                                                                    value={editForm.urlAttendee}
                                                                    onChange={(e) => setEditForm((prev) => ({ ...prev, urlAttendee: e.target.value }))}
                                                                />
                                                            </div>
                                                        </Modal.Body>
                                                        <Modal.Footer>
                                                            <Button variant="secondary" onClick={() => setEditModalOpen(false)}>İptal</Button>
                                                            <Button type="submit" variant="primary" disabled={isSavingEdit}>
                                                                {isSavingEdit ? 'Kaydediliyor...' : 'Kaydet'}
                                                            </Button>
                                                        </Modal.Footer>
                                                    </form>
                                                </Modal>
                                            </a>
                                        </>
                                    ) : (
                                        <>
                                            {String(meeting?.status ?? '0') === '1' ? (
                                                <div className="media">
                                                    <span className="me-3">
                                                        <i className="fa fa-ban text-danger"></i>
                                                    </span>
                                                    <div className="media-body">
                                                        <h5 className="text-danger">Toplantı İptal Edildi</h5>
                                                    </div>
                                                </div>
                                            ) : new Date(new Date(meeting.startDate).getTime() - 5 * 60000) <= new Date() &&
                                                new Date(new Date(meeting.endDate).getTime() + 5 * 60000) >= new Date() ? (
                                                <>
                                                    {meeting && Array.isArray(meeting.adminUsers) && meeting.adminUsers.includes(myUserId) ? (
                                                        <a href={meeting.urlHost || "#"}>
                                                            <div className="media">
                                                                <span className="me-3">
                                                                    <i className="fa fa-play"></i>
                                                                </span>
                                                                <div className="media-body">
                                                                    <h4 className="">Toplantı Devam Ediyor</h4>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    ) : (
                                                        <a href={meeting && meeting.urlAttendee ? meeting.urlAttendee : "#"}>
                                                            <div className="media">
                                                                <span className="me-3">
                                                                    <i className="fa fa-play"></i>
                                                                </span>
                                                                <div className="media-body">
                                                                    <h4 className="">Toplantı Devam Ediyor</h4>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {new Date(meeting.startDate) >= new Date() && new Date(meeting.endDate) >= new Date() ? (
                                                        <>
                                                            <div className="media">
                                                                <span className="me-3">
                                                                    <i className="fa fa-check"></i>
                                                                </span>
                                                                <div className="media-body">
                                                                    <h5 className="">Toplantı Başlamadı</h5>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="media">
                                                                <span className="me-3">
                                                                    <i className="fa fa-check"></i>
                                                                </span>
                                                                <div className="media-body">
                                                                    <h5 className="">Toplantı Sona Erdi</h5>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            )}

                                        </>
                                    )}
                                    <Modal show={lionModalOpen} onHide={() => setLionModalOpen(false)} centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>
                                                {lionSectionKey ? LION_SECTIONS[lionSectionKey] : 'LION Note'}
                                            </Modal.Title>
                                        </Modal.Header>

                                        <form onSubmit={saveLionNote}>
                                            <Modal.Body>
                                                <div className="mb-3">
                                                    <label className="form-label">Başlık</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={lionForm.title}
                                                        onChange={(e) => setLionForm((f) => ({ ...f, title: e.target.value }))}
                                                        placeholder="Örn: Önceki haftanın özeti"
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">Detay</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={4}
                                                        value={lionForm.details}
                                                        onChange={(e) => setLionForm((f) => ({ ...f, details: e.target.value }))}
                                                        placeholder="Not ayrıntıları"
                                                    />
                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={() => setLionModalOpen(false)}>
                                                    Kapat
                                                </Button>
                                                <Button variant="primary" type="submit" disabled={lionSaving}>
                                                    {lionSaving ? 'Kaydediliyor...' : 'Kaydet'}
                                                </Button>
                                            </Modal.Footer>
                                        </form>
                                    </Modal>

                                </div>
                            </div>
                        </div>



                        <div className="col-lg-12">
                            <div className="card">

                                <div className="card-body">

                                    {/* Hakkında  */}
                                    <div className="media align-items-center border-bottom p-2" onClick={() => setTabAndUrl("about")}>
                                        <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                            <i className="fa fa-info fs-16" aria-hidden="true"></i>
                                        </div>
                                        <div className="media-body">
                                            <h5 className="mt-0 mb-0">Hakkında</h5>
                                        </div>
                                    </div>


                                    {/* LION Paneli */}
                                    {IS_LION && (
                                        <div className="media align-items-center border-bottom p-2" onClick={() => setTabAndUrl("lion")}>
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-shield fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0" onClick={() => setTabAndUrl("lion")}>LION</h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* LION template için My Notes sekmesini gizle */}
                                    {!IS_LION && (
                                        <div className="media align-items-center border-bottom p-2" onClick={() => setTabAndUrl("notes")}>
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-edit fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0" onClick={() => setTabAndUrl("notes")}>Notlarım</h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* Gündem menü itemı */}
                                    {!IS_LION && !IS_BIREBIR && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={isPremiumFinal ? () => setTabAndUrl("agenda") : handlePremiumGate}
                                        >
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-calendar fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">
                                                    Gündem {!isPremiumFinal && <span className="ms-2 text-warning">★ Premium</span>}
                                                </h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* Kararlar menü itemı */}
                                    {!IS_LION && !IS_BIREBIR && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={isPremiumFinal ? () => setTabAndUrl("decision") : handlePremiumGate}
                                        >
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-check fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">
                                                    Kararlar {!isPremiumFinal && <span className="ms-2 text-warning">★ Premium</span>}
                                                </h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* Katılımcılar – BİREBİR’de gizle */}
                                    {!IS_BIREBIR && (
                                        <div className="media align-items-center border-bottom p-2" onClick={() => setTabAndUrl("participants")}>
                                            <div className="ticket-icon44 ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-users fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">Katılımcılar</h5>
                                            </div>
                                        </div>
                                    )}


                                    {/* LION template için Meeting Record sekmesini gizle */}
                                    {!IS_LION && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={isPremiumFinal ? () => setTabAndUrl("record") : handlePremiumGate}
                                        >
                                            <div className="ticket-icon44  ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-microphone fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">
                                                    Toplantı Kaydı {!isPremiumFinal && <span className="ms-2 text-warning">★ Premium</span>}
                                                </h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* Toplantı Dökümü: yalnızca transkript varsa ve BİREBİR değilse */}
                                    {meeting?.isTranscribed && !IS_BIREBIR && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={() => setTabAndUrl("transcript")}
                                        >
                                            <div className="ticket-icon44 ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-pencil fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">Toplantı Dökümü</h5>
                                            </div>
                                        </div>
                                    )}

                                    {/* Yapay Zeka ile Analiz: yalnızca transkript varsa ve BİREBİR değilse */}
                                    {meeting?.isTranscribed && !IS_BIREBIR && (
                                        <div
                                            className="media align-items-center border-bottom p-2"
                                            onClick={() => setTabAndUrl("meetingAI")}
                                        >
                                            <div className="ticket-icon44 ms-0 me-3 d-none d-sm-inline-block">
                                                <i className="fa fa-file-text fs-16" aria-hidden="true"></i>
                                            </div>
                                            <div className="media-body">
                                                <h5 className="mt-0 mb-0">Yapay Zeka ile Analiz</h5>
                                            </div>
                                        </div>
                                    )}

                                    <div className="media align-items-center border-bottom p-2">
                                        <div className="w-100 d-grid gap-2">
                                            <button
                                                className="btn w-100 text-start border border-primary-subtle rounded-3 py-2 px-3"
                                                style={{ background: "linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%)" }}
                                                onClick={async () => {
                                                    try {
                                                        await exportMeetingSummaryPDF({
                                                            meeting,
                                                            agendas: meetingAgendas,
                                                            decisions: meetingDecisions,
                                                            users: meetingUsers,
                                                            notes: meetingNotes,
                                                            speakers: meetingSpeakers,
                                                            aiDetail: mergedMeetingAI || {},
                                                            lionNotesBySection: IS_LION ? lionNotesBySection : null,
                                                        });
                                                    } catch (e) {
                                                        console.error("PDF export error:", e);
                                                    }
                                                }}
                                            >
                                                <div className="d-flex align-items-center gap-2">
                                                    <i className="fa fa-file-pdf-o text-primary" />
                                                    <span className="fw-semibold text-primary">Toplantı Özeti</span>
                                                </div>
                                                <div className="small text-muted ms-4">Başlık, tarih, katılımcılar, gündem ve kararlar</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <div className="col-xl-8">
                    <div className="card">
                        <div className="card-body">
                            <div className="profile-tab">
                                <div className="custom-tab-1">

                                    <div className="tab-content">

                                        <div id="about" className={`tab-pane fade ${activeToggle === "about" ? "active show" : ""}`}>
                                            <div className="d-flex align-items-center justify-content-between mb-4">
                                                <h4 className="text-info mb-0">Hakkında</h4>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-light border rounded-circle d-inline-flex align-items-center justify-content-center"
                                                    onClick={openAboutEditModal}
                                                    title="Düzenle"
                                                    style={{ width: 34, height: 34 }}
                                                >
                                                    <i className="fa fa-pencil text-primary" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                            <p className="mb-2">{meetingBriefing}</p>
                                            {meetingOnlineLink && (
                                                <div className="mt-3">
                                                    <h6 className="text-info mb-2">Online Toplantı Linki</h6>
                                                    <a
                                                        href={meetingOnlineLink}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ wordBreak: 'break-all' }}
                                                    >
                                                        {meetingOnlineLink}
                                                    </a>
                                                </div>
                                            )}
                                        </div>

                                        {/* LION Paneli – SAĞDA, sadece LION şablonda */}
                                        {IS_LION && (
                                            <div
                                                id="lion"
                                                className={`tab-pane fade ${activeToggle === "lion" ? "active show" : ""}`}
                                            >
                                                <h4 className="text-info mb-4">LION</h4>
                                                <div className="mb-3">
                                                    <div className="small text-muted mb-2">Katılımcı Filtrele</div>
                                                    <div className="d-flex flex-wrap gap-3">
                                                        {lionParticipants.map((u) => {
                                                            const uid = u?.uid || u?.userId || u?.id;
                                                            if (!uid) return null;
                                                            const label = [u?.name, u?.surName].filter(Boolean).join(' ') || u?.userEmail || 'Bilinmeyen';
                                                            const checked = selectedLionUserId === uid;
                                                            return (
                                                                <label key={uid} className="d-flex align-items-center m-0">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="me-2"
                                                                        checked={checked}
                                                                        onChange={() => toggleLionUser(uid)}
                                                                    />
                                                                    <span className="text-dark" style={{ whiteSpace: 'nowrap' }}>{label}</span>
                                                                </label>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                                <div className="row g-3">
                                                    {/* Last Week */}
                                                    <div className="col-md-6">
                                                        <div
                                                            className="p-4 rounded"
                                                            style={{ background: "#ff80b3", cursor: "pointer" }}
                                                            onClick={() => openLionModal("lastWeek")}
                                                        >
                                                            <h5 className="text-white mb-0">Last Week</h5>
                                                        </div>
                                                        <div className="mt-2 bg-white rounded p-2">
                                                            {filterLionNotes(lionNotesBySection.lastWeek).length === 0 ? (
                                                                <small className="text-muted">Henüz not yok.</small>
                                                            ) : (
                                                                <ul className="mb-0" style={{ listStyle: "disc", paddingLeft: 18 }}>
                                                                    {filterLionNotes(lionNotesBySection.lastWeek).map((note) => (
                                                                        <li key={note.id}>
                                                                            <strong>{note.title}</strong>
                                                                            {note.context && <> – {note.context}</>}
                                                                            <div className="small text-muted">Yazan: {getLionUserLabel(note.userId)}</div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Issues & Solutions */}
                                                    <div className="col-md-6">
                                                        <div
                                                            className="p-4 rounded"
                                                            style={{ background: "#2fb5ff", cursor: "pointer" }}
                                                            onClick={() => openLionModal("issues")}
                                                        >
                                                            <h5 className="text-white mb-0">Issues &amp; Solutions</h5>
                                                        </div>
                                                        <div className="mt-2 bg-white rounded p-2">
                                                            {filterLionNotes(lionNotesBySection.issues).length === 0 ? (
                                                                <small className="text-muted">Henüz not yok.</small>
                                                            ) : (
                                                                <ul className="mb-0" style={{ listStyle: "disc", paddingLeft: 18 }}>
                                                                    {filterLionNotes(lionNotesBySection.issues).map((note) => (
                                                                        <li key={note.id}>
                                                                            <strong>{note.title}</strong>
                                                                            {note.context && <> – {note.context}</>}
                                                                            <div className="small text-muted">Yazan: {getLionUserLabel(note.userId)}</div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Opportunities */}
                                                    <div className="col-md-6">
                                                        <div
                                                            className="p-4 rounded"
                                                            style={{ background: "#23d3ee", cursor: "pointer" }}
                                                            onClick={() => openLionModal("opportunities")}
                                                        >
                                                            <h5 className="text-white mb-0">Opportunities</h5>
                                                        </div>
                                                        <div className="mt-2 bg-white rounded p-2">
                                                            {filterLionNotes(lionNotesBySection.opportunities).length === 0 ? (
                                                                <small className="text-muted">Henüz not yok.</small>
                                                            ) : (
                                                                <ul className="mb-0" style={{ listStyle: "disc", paddingLeft: 18 }}>
                                                                    {filterLionNotes(lionNotesBySection.opportunities).map((note) => (
                                                                        <li key={note.id}>
                                                                            <strong>{note.title}</strong>
                                                                            {note.context && <> – {note.context}</>}
                                                                            <div className="small text-muted">Yazan: {getLionUserLabel(note.userId)}</div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Next Week */}
                                                    <div className="col-md-6">
                                                        <div
                                                            className="p-4 rounded"
                                                            style={{ background: "#b3a4ff", cursor: "pointer" }}
                                                            onClick={() => openLionModal("nextWeek")}
                                                        >
                                                            <h5 className="text-white mb-0">Next Week</h5>
                                                        </div>
                                                        <div className="mt-2 bg-white rounded p-2">
                                                            {filterLionNotes(lionNotesBySection.nextWeek).length === 0 ? (
                                                                <small className="text-muted">Henüz not yok.</small>
                                                            ) : (
                                                                <ul className="mb-0" style={{ listStyle: "disc", paddingLeft: 18 }}>
                                                                    {filterLionNotes(lionNotesBySection.nextWeek).map((note) => (
                                                                        <li key={note.id}>
                                                                            <strong>{note.title}</strong>
                                                                            {note.context && <> – {note.context}</>}
                                                                            <div className="small text-muted">Yazan: {getLionUserLabel(note.userId)}</div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {/* Meeting Record Tab - LION template için gizle */}
                                        {!IS_LION && (
                                            <div id="record" className={`tab-pane fade ${activeToggle === "record" ? "active show" : ""}`}>
                                                {isPremiumFinal ? (
                                                    <>
                                                        <h4 className="text-info mb-4">Toplantı Kaydı</h4>

                                                        {/* Mevcut kayıt bölümü */}
                                                        {meetingRecordList.length > 0 ? (
                                                            <div className="existing-recording p-3 mb-4 bg-white rounded shadow-sm">
                                                                <h6 className="text-info mb-3">
                                                                    <i className="fa fa-headphones me-2"></i>
                                                                    Mevcut Kayıtlar
                                                                </h6>
                                                                {meetingRecordList.map((record) => {
                                                                    const recordDate = toDate(record?.updateDate || record?.createDate);
                                                                    return (
                                                                        <div key={record.id} className="d-flex align-items-center py-2 border-bottom">
                                                                            <i className="fa fa-file-audio-o fa-2x text-info me-3"></i>
                                                                            <div className="text-start">
                                                                                <p className="mb-0 fw-bold text-truncate" style={{ maxWidth: "350px" }}>
                                                                                    {record.name || record.fileName || "Toplantı Ses Kaydı"}
                                                                                </p>
                                                                                {recordDate && (
                                                                                    <small className="text-muted">
                                                                                        Yüklenme: {recordDate.toLocaleString('tr-TR')}
                                                                                    </small>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        ) : <></>}

                                                        <div className="upload-area mb-4">
                                                            <form onSubmit={handleRecordSubmit} className="text-center">
                                                                <div
                                                                    style={{
                                                                        ...styles.uploadContainer,
                                                                        ...(isDragging ? styles.uploadContainerDragging : {})
                                                                    }}
                                                                    className="position-relative"
                                                                    onDragOver={handleDragOver}
                                                                    onDragLeave={handleDragLeave}
                                                                    onDrop={handleDrop}
                                                                >
                                                                    {isUploading ? (
                                                                        <div className="mb-4">
                                                                            <div className="d-flex justify-content-between mb-2">
                                                                                <span className="text-muted">Yükleniyor...</span>
                                                                                <span className="fw-bold">{uploadProgress}%</span>
                                                                            </div>
                                                                            <div className="progress mb-3" style={{ height: "20px" }}>
                                                                                <div
                                                                                    className="progress-bar progress-bar-striped progress-bar-animated bg-info"
                                                                                    role="progressbar"
                                                                                    style={{ width: `${uploadProgress}%`, ...styles.progressBar }}
                                                                                    aria-valuenow={uploadProgress}
                                                                                    aria-valuemin="0"
                                                                                    aria-valuemax="100"
                                                                                >
                                                                                    {uploadProgress}%
                                                                                </div>
                                                                            </div>
                                                                            <div className="alert alert-warning">
                                                                                <i className="fa fa-exclamation-triangle me-2"></i>
                                                                                Lütfen yükleme tamamlanana kadar sayfadan ayrılmayın.
                                                                            </div>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-danger mt-2"
                                                                                onClick={() => {
                                                                                    setIsUploading(false);
                                                                                    setUploadProgress(0);
                                                                                    window.onbeforeunload = null;
                                                                                    toast.error('Yükleme iptal edildi', { id: 'audioUpload' });
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-times me-1"></i>
                                                                                İptal Et
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {selectedFiles.length > 0 ? (
                                                                                <div style={styles.selectedFile} className="p-3 bg-white rounded shadow-sm">
                                                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                                                        <p className="mb-0 fw-bold text-start">{selectedFiles.length} dosya seçildi</p>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm btn-outline-danger"
                                                                                            onClick={() => setSelectedFiles([])}
                                                                                        >
                                                                                            <i className="fa fa-times me-1"></i>Tümünü Kaldır
                                                                                        </button>
                                                                                    </div>
                                                                                    <div className="text-start" style={{ maxHeight: "180px", overflowY: "auto" }}>
                                                                                        {selectedFiles.map((file, index) => (
                                                                                            <div key={`${file.name}-${file.size}-${index}`} className="d-flex align-items-center justify-content-between py-1 border-bottom">
                                                                                                <div className="d-flex align-items-center">
                                                                                                    <i className="fa fa-file-audio-o text-info me-2"></i>
                                                                                                    <small className="text-truncate d-inline-block" style={{ maxWidth: "220px" }}>{file.name}</small>
                                                                                                </div>
                                                                                                <small className="text-muted ms-2">{(file.size / (1024 * 1024)).toFixed(2)} MB</small>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                    <div className="mt-4 d-flex justify-content-center">
                                                                                        <button
                                                                                            type="submit"
                                                                                            className="btn btn-success px-4 py-2"
                                                                                            disabled={isUploading}
                                                                                        >
                                                                                            <i className="fa fa-cloud-upload me-2"></i>
                                                                                            Kayıt Yükle
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <>
                                                                                    <div className="text-center mb-3">
                                                                                        <i className="fa fa-cloud-upload fa-4x text-info mb-3"></i>
                                                                                        <h5 className="fw-bold">Ses kaydı yüklemek için buraya sürükleyin</h5>
                                                                                        <p className="text-muted">veya</p>
                                                                                    </div>
                                                                                    <input
                                                                                        type="file"
                                                                                        id="meeting-audio-upload"
                                                                                        className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
                                                                                        accept="audio/*,.mp3,.wav,.m4a,.aac,.ogg,.mp4"
                                                                                        multiple
                                                                                        onChange={handleFileChange}
                                                                                        style={{ cursor: 'pointer' }}
                                                                                    />
                                                                                    <button type="button" className="btn btn-info px-4 py-2">
                                                                                        <i className="fa fa-file-audio-o me-2"></i>Dosya Seç
                                                                                    </button>
                                                                                    <div className="mt-3">
                                                                                        <small className="text-muted">Desteklenen formatlar: MP3, WAV, M4A, AAC, OGG, MP4</small>
                                                                                        <br />
                                                                                        <small className="text-muted">Maksimum dosya boyutu (dosya başına): 250MB</small>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </>
                                                ) : (
                                                    renderPremiumUpsell("Toplantı Kaydı")
                                                )}
                                            </div>
                                        )}

                                        <div id="transcript" className={`tab-pane fade ${activeToggle === "transcript" ? "active show" : ""}`}>

                                            <div className="custom-tab-1">
                                                {meetingRecordsAI.length > 0 && (
                                                    <div className="mt-3 mb-2">
                                                        <div className="d-flex align-items-center flex-wrap">
                                                            {meetingRecordsAI.map((_, index) => (
                                                                <button
                                                                    key={`record-tab-${index}`}
                                                                    type="button"
                                                                    className={`btn btn-link p-0 ${index === selectedRecordIndex ? "text-primary fw-bold" : "text-muted"}`}
                                                                    onClick={() => setSelectedRecordIndex(index)}
                                                                >
                                                                    Kayıt {index + 1}
                                                                </button>
                                                            )).reduce((prev, curr, index) => {
                                                                if (index === 0) return [curr];
                                                                return [...prev, <span key={`sep-${index}`} className="mx-2 text-muted">|</span>, curr];
                                                            }, [])}
                                                        </div>
                                                    </div>
                                                )}

                                                <ul className="nav nav-tabs">
                                                    <li className="nav-item" onClick={() => setActiveTab2("meetingTranscript")}>
                                                        <button type="button" className={`nav-link btn btn-link ${activeTab2 === "meetingTranscript" ? "active show" : ""}`}>Toplantı Dökümü</button>
                                                    </li>
                                                    <li className="nav-item" onClick={() => setActiveTab2("meetingSpeakers")}>
                                                        <button type="button" className={`nav-link btn btn-link ${activeTab2 === "meetingSpeakers" ? "active show" : ""}`}>Toplantı Konuşmaları</button>
                                                    </li>
                                                </ul>

                                                <div className="tab-content">

                                                    <div id="meetingTranscript" className={`tab-pane fade ${activeTab2 === "meetingTranscript" ? "active show" : ""}`} >

                                                        <h5 className="text-info mb-2 mt-5">Toplantı Dökümü</h5>
                                                        <p className="mb-15">
                                                            {transcriptText}
                                                        </p>

                                                    </div>

                                                    <div id="meetingSpeakers" className={`tab-pane fade ${activeTab2 === "meetingSpeakers" ? "active show" : ""}`} >

                                                        <h5 className="text-info mb-2 mt-5">Toplantı Konuşmaları</h5>
                                                        {transcriptSpeakers.map((list, index) => (
                                                            <div key={index} className="media mb-5 align-items-center event-list">
                                                                <div className="p-3 text-center me-3 date-bx bgl-info">
                                                                    <h2 className="mb-0 text-secondary fs-16 font-w600">
                                                                        {formatToMinutesAndSeconds(list.start)}
                                                                    </h2>
                                                                    <h5 className="mb-1 text-black fs-16 ">
                                                                        {formatToMinutesAndSeconds(list.end)}
                                                                    </h5>
                                                                </div>
                                                                <div className="media-body px-0">
                                                                    <h6 className="mt-0 mb-0 fs-16 text-bold">{list.speaker}</h6>
                                                                    <p className="mt-0 mb-3 fs-14 text-bold">{list.text}</p>
                                                                </div>
                                                            </div>
                                                        ))}

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        {/* Gündem секmesi - Premium */}
                                        {!IS_LION && !IS_BIREBIR && (
                                            <div
                                                id="agenda"
                                                className={`tab-pane fade ${activeToggle === "agenda" ? "active show" : ""}`}
                                            >
                                                {isPremiumFinal ? (
                                                    <>
                                                        <div className="d-flex align-items-center justify-content-between mb-4">
                                                            <h4 className="text-info mb-0">Gündem</h4>
                                                            <button type="button" className="btn btn-primary btn-sm rounded-pill" onClick={openAgendaAddModal}>
                                                                Gündem Ekle
                                                            </button>
                                                        </div>
                                                        {meetingAgendas.map((list, index) => (
                                                            <div key={index} className="media mb-4 align-items-center event-list p-3 border rounded-3 bg-white">
                                                                <div className="p-3 text-center me-3 date-bx bgl-info">
                                                                    <h2 className="mb-0 text-secondary fs-16 font-w600">
                                                                        {getFormattedTimeFromMillis(list.startTime)}
                                                                    </h2>
                                                                    <h5 className="mb-1 text-black fs-16 ">
                                                                        {getFormattedTimeFromMillis(list.endTime)}
                                                                    </h5>
                                                                </div>
                                                                <div className="media-body px-0">
                                                                    <div className="d-flex align-items-start justify-content-between gap-2">
                                                                        <h6 className="mt-0 mb-0 fs-16 text-bold">{list.title}</h6>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-light border rounded-circle d-inline-flex align-items-center justify-content-center"
                                                                            onClick={() => openAgendaEditModal(list)}
                                                                            title="Düzenle"
                                                                            style={{ width: 34, height: 34 }}
                                                                        >
                                                                            <i className="fa fa-pencil text-primary" aria-hidden="true"></i>
                                                                        </button>
                                                                    </div>
                                                                    <p className="mt-2 mb-2 fs-14 text-bold">{list.details}</p>
                                                                    {Array.isArray(list?.users) && list.users.length > 0 && (
                                                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                            <span className="small text-muted">Görevliler:</span>
                                                                            {list.users.map((uid) => (
                                                                                <span key={`${list.id || index}-${uid}`} className="badge rounded-pill bg-light text-dark border">
                                                                                    {findParticipantName(uid)}
                                                                                </span>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    renderPremiumUpsell("Gündem")
                                                )}
                                            </div>
                                        )}

                                        {/* Katılımcılar sekmesi – LION template için gizle */}
                                        {!IS_BIREBIR && (
                                            <div id="participants" className={`tab-pane fade ${activeToggle === "participants" ? "active show" : ""}`}>
                                                <h4 className="text-info mb-4">Katılımcılar</h4>
                                                <form onSubmit={onAddParticipantByEmail} className="mb-4">
                                                    <label className="form-label">E-posta ile katılımcı ekle</label>
                                                    <div className="d-flex gap-2">
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            placeholder="ornek@domain.com"
                                                            value={participantEmail}
                                                            onChange={(e) => setParticipantEmail(e.target.value)}
                                                        />
                                                        <button type="submit" className="btn btn-info" disabled={isAddingParticipant}>
                                                            {isAddingParticipant ? 'Ekleniyor...' : 'Ekle'}
                                                        </button>
                                                    </div>
                                                    {participantInviteError && (
                                                        <div className="text-danger mt-2 fs-14">{participantInviteError}</div>
                                                    )}
                                                </form>
                                                <div className="mb-2">
                                                    {meetingUsers.map((list, index) => (
                                                        <div key={index} className="media pb-3 border-bottom mb-3 align-items-center">
                                                            <Link to={"/Profile/" + list.userId} className="d-flex align-items-center flex-grow-1">
                                                                <div className="media-image me-2">
                                                                    {list.thumbnail == "" ? (
                                                                        <img src={"https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"} alt="" />
                                                                    ) : (
                                                                        <img src={list.thumbnail} alt="" />
                                                                    )}
                                                                </div>
                                                                <div className="media-body">
                                                                    <h6 className="fs-16 mb-0">{list.name + " " + list.surName}</h6>
                                                                    <div className="d-flex">
                                                                        <span className="fs-14 me-auto text-secondary">
                                                                            {list.businessName + " " + list.job}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                            {Array.isArray(meeting?.adminUsers) &&
                                                                meeting.adminUsers.includes(myUserId) &&
                                                                list.userId !== myUserId && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-danger ms-2"
                                                                        disabled={removingParticipantId === list.userId}
                                                                        onClick={() => onRemoveParticipant(list.userId)}
                                                                    >
                                                                        {removingParticipantId === list.userId ? 'Çıkarılıyor...' : 'Çıkar'}
                                                                    </button>
                                                                )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* Notes Tab - LION template için gizle */}
                                        {!IS_LION && (
                                            <div id="notes" className={`tab-pane fade ${activeToggle === "notes" ? "active show" : ""}`}>
                                                <h4 className="text-info mb-4">Notlarım</h4>
                                                <div className="mb-2">
                                                    <div className="post-input">
                                                        <form onSubmit={onSubmitNote}>
                                                            <div className="p-3 border rounded-3 bg-white">
                                                                <input
                                                                    type="text"
                                                                    value={noteTitle}
                                                                    onChange={(e) => setNoteTitle(e.target.value)}
                                                                    className="form-control mb-2"
                                                                    placeholder="Başlık"
                                                                    style={{
                                                                        height: 44,
                                                                        borderRadius: 12,
                                                                        border: '1px solid #d7dde6',
                                                                        boxShadow: 'none',
                                                                        padding: '0 14px'
                                                                    }}
                                                                />
                                                                <textarea
                                                                    value={noteContext}
                                                                    onChange={(e) => setNoteContext(e.target.value)}
                                                                    name="textarea"
                                                                    id="textarea"
                                                                    rows={3}
                                                                    className="form-control bg-transparent"
                                                                    placeholder="Detay"
                                                                    style={{
                                                                        resize: 'vertical',
                                                                        minHeight: 96,
                                                                        borderRadius: 12,
                                                                        border: '1px solid #d7dde6',
                                                                        boxShadow: 'none',
                                                                        padding: '10px 14px'
                                                                    }}
                                                                />
                                                                <div className="d-flex justify-content-end mt-2">
                                                                    <button className='btn btn-primary btn-sm rounded-pill px-3' type='submit' title="Ekle">
                                                                        <i className="fa fa-plus me-1" aria-hidden="true"></i> Ekle
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                    <PerfectScrollbar
                                                        id="DZ_W_TimeLine"
                                                        className="widget-timeline dz-scroll  ps ps--active-y" >
                                                        <ul className="timeline">
                                                            {meetingNotes.map((list, index) => (
                                                                <li key={index}>
                                                                    <div className="timeline-badge dark"></div>
                                                                    <div className="timeline-panel text-muted">
                                                                        <div className="d-flex align-items-start justify-content-between gap-2">
                                                                            <h6 className="mb-0">{list.title}</h6>
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <small className="text-muted text-end">
                                                                                    {toDate(list?.messageDate)?.toLocaleString('tr-TR', {
                                                                                        day: '2-digit',
                                                                                        month: '2-digit',
                                                                                        year: 'numeric',
                                                                                        hour: '2-digit',
                                                                                        minute: '2-digit',
                                                                                    }) || '-'}
                                                                                </small>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-light border rounded-circle d-inline-flex align-items-center justify-content-center"
                                                                                    onClick={() => openNoteEditModal(list)}
                                                                                    title="Düzenle"
                                                                                    style={{ width: 30, height: 30 }}
                                                                                >
                                                                                    <i className="fa fa-pencil text-primary" aria-hidden="true"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <p>{list.context}</p>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </PerfectScrollbar>
                                                </div>
                                            </div>
                                        )}

                                        <div id="chat" className={`tab-pane fade ${activeToggle === "chat" ? "active show" : ""}`}>
                                            <h4 className="text-info mb-4">Sohbet</h4>
                                            <p className="mb-2"></p>
                                        </div>

                                        {/* Kararlar секmesi - Premium */}
                                        {!IS_LION && !IS_BIREBIR && (
                                            <div
                                                id="decision"
                                                className={`tab-pane fade ${activeToggle === "decision" ? "active show" : ""}`}
                                            >
                                                {isPremiumFinal ? (
                                                    <>
                                                        <div className="d-flex align-items-center justify-content-between mb-4">
                                                            <h4 className="text-info mb-0">Kararlar</h4>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className="badge bg-info-subtle text-info border border-info-subtle">
                                                                    {sortedMeetingDecisions.length} Kayıt
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-sm rounded-pill"
                                                                    onClick={() => setIsDecisionAddOpen(true)}
                                                                >
                                                                    Karar Ekle
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {(!meetingDecisions || meetingDecisions.length === 0) && (
                                                            <div className="text-muted fs-14 p-4 border rounded-3 bg-light">Henüz karar eklenmemiş.</div>
                                                        )}

                                                        {sortedMeetingDecisions?.map((list) => (
                                                            <div
                                                                key={list.id || list.decisionId}
                                                                className="mb-3 p-3 p-md-4 border rounded-4 bg-white shadow-sm"
                                                            >
                                                                <div className="d-flex align-items-start gap-3">
                                                                    <div
                                                                        className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                                                                        style={{
                                                                            width: 44,
                                                                            height: 44,
                                                                            background: 'linear-gradient(160deg, #e8f2ff 0%, #f3f8ff 100%)',
                                                                            border: '1px solid #d6e6ff'
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-check text-primary" aria-hidden="true"></i>
                                                                    </div>
                                                                    <div className="flex-grow-1">
                                                                        <div className="d-flex align-items-start justify-content-between gap-2 flex-wrap">
                                                                            <h6 className="mt-0 mb-2 fs-18 fw-semibold text-dark">{list.title}</h6>
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-light border rounded-circle d-inline-flex align-items-center justify-content-center"
                                                                                    onClick={() => openDecisionEditModal(list)}
                                                                                    title="Düzenle"
                                                                                    style={{ width: 34, height: 34 }}
                                                                                >
                                                                                    <i className="fa fa-pencil text-primary" aria-hidden="true"></i>
                                                                                </button>
                                                                                <span className="badge rounded-pill text-bg-light border text-muted">
                                                                                    #{(list.title || '').match(/\d+/)?.[0] || '-'}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <p className="mt-0 mb-3 fs-15 text-dark" style={{ lineHeight: 1.6 }}>
                                                                            {list.details}
                                                                        </p>
                                                                        <div className="d-flex align-items-center gap-2 flex-wrap mb-3">
                                                                            <button
                                                                                type="button"
                                                                                className={`badge rounded-pill border-0 ${list?.isComplate ? 'bg-success-subtle text-success border border-success-subtle' : 'bg-warning-subtle text-warning border border-warning-subtle'}`}
                                                                                onClick={() => toggleDecisionCompletion(list)}
                                                                                title="Durumu değiştir"
                                                                                style={{ cursor: 'pointer' }}
                                                                            >
                                                                                {list?.isComplate ? 'Tamamlandı' : 'Devam Ediyor'}
                                                                            </button>
                                                                            <span className="badge rounded-pill text-bg-light border text-muted">
                                                                                Son Tarih: {toInputDateValue(list?.deadLine) || '-'}
                                                                            </span>
                                                                        </div>
                                                                        {Array.isArray(list?.users) && list.users.length > 0 && (
                                                                            <div className="d-flex align-items-center gap-2 flex-wrap mb-2">
                                                                                <span className="small text-muted">Görevliler:</span>
                                                                                {list.users.map((uid) => (
                                                                                    <span key={`${list.id || list.decisionId}-${uid}`} className="badge rounded-pill bg-light text-dark border">
                                                                                        {findParticipantName(uid)}
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    renderPremiumUpsell("Kararlar")
                                                )}
                                            </div>
                                        )}

                                        <div id="files" className={`tab-pane fade ${activeToggle === "files" ? "active show" : ""}`}>
                                            <h4 className="text-info mb-4">Dosyalar</h4>
                                            <p className="mb-2"></p>
                                        </div>

                                        <div id="meetingAI" className={`tab-pane fade ${activeToggle === "meetingAI" ? "active show" : ""}`}>

                                            <div className="custom-tab-1">
                                                {aiRecordsForDisplay.length > 0 && (
                                                    <div className="mt-3 mb-2">
                                                        <div className="d-flex align-items-center flex-wrap">
                                                            {aiRecordsForDisplay.map((item, index) => (
                                                                <button
                                                                    key={`meeting-ai-record-tab-${index}`}
                                                                    type="button"
                                                                    className={`btn btn-link p-0 ${index === selectedAIRecordIndex ? "text-primary fw-bold" : "text-muted"}`}
                                                                    onClick={() => setSelectedAIRecordIndex(index)}
                                                                >
                                                                    {item?.isMerged ? 'Birleştirilmiş' : `Kayıt ${mergedMeetingAI ? index : index + 1}`}
                                                                </button>
                                                            )).reduce((prev, curr, index) => {
                                                                if (index === 0) return [curr];
                                                                return [...prev, <span key={`meeting-ai-sep-${index}`} className="mx-2 text-muted">|</span>, curr];
                                                            }, [])}
                                                        </div>
                                                    </div>
                                                )}

                                                <ul className="nav nav-tabs">
                                                    <li className="nav-item" onClick={() => setActiveTab("meetingAIDetailSummary")}>
                                                        <button type="button" className={`nav-link btn btn-link ${activeTab === "meetingAIDetailSummary" ? "active show" : ""}`}>Özet</button>
                                                    </li>
                                                    <li className="nav-item" onClick={() => setActiveTab("meetingAIDetailAgenda")}>
                                                        <button type="button" className={`nav-link btn btn-link ${activeTab === "meetingAIDetailAgenda" ? "active show" : ""}`}>Gündem</button>
                                                    </li>
                                                    <li className="nav-item" onClick={() => setActiveTab("meetingAIDetailDecisions")} >
                                                        <button type="button" className={`nav-link btn btn-link ${activeTab === "meetingAIDetailDecisions" ? "active show" : ""}`}>Karar</button>
                                                    </li>
                                                    <li className="nav-item" onClick={() => setActiveTab("meetingAIDetailNextAgendaSuggestion")} >
                                                        <button type="button" className={`nav-link btn btn-link ${activeTab === "meetingAIDetailNextAgendaSuggestion" ? "active show" : ""}`}>Öneri</button>
                                                    </li>
                                                </ul>

                                                <div className="tab-content">

                                                    <div id="meetingAIDetailSummary" className={`tab-pane fade ${activeTab === "meetingAIDetailSummary" ? "active show" : ""}`} >

                                                        <h5 className="text-info mb-2 mt-5">Toplantı Özeti</h5>
                                                        <p className="mb-15">
                                                            {selectedMeetingAIDetail.summary}
                                                        </p>

                                                        {selectedMeetingSpeechAnalysis?.analysis && (
                                                            <div className="mt-4">
                                                                <h5 className="text-info mb-2">Konuşma Analizi</h5>
                                                                <div className="row">
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="p-3 border rounded">
                                                                            <div className="fw-bold text-dark">Genel Özet</div>
                                                                            <div className="text-dark mt-1">
                                                                                {selectedMeetingSpeechAnalysis.analysis.generalSummary || "-"}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="p-3 border rounded">
                                                                            <div className="fw-bold text-dark">Verimlilik</div>
                                                                            <div className="text-dark mt-1">
                                                                                %{selectedMeetingSpeechAnalysis.analysis.efficiencyPercent ?? "-"}
                                                                            </div>
                                                                            <div className="small text-muted mt-2">
                                                                                Üretken: {selectedMeetingSpeechAnalysis.analysis.productiveMinutes ?? "-"} dk ·
                                                                                Üretken olmayan: {selectedMeetingSpeechAnalysis.analysis.nonProductiveMinutes ?? "-"} dk ·
                                                                                Konu dışı: {selectedMeetingSpeechAnalysis.analysis.offTopicMinutes ?? "-"} dk
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="row">
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="p-3 border rounded">
                                                                            <div className="fw-bold text-dark">En Üretken Konuşmacılar</div>
                                                                            <div className="text-dark mt-1">
                                                                                {Array.isArray(selectedMeetingSpeechAnalysis.analysis.mostProductiveSpeakers) && selectedMeetingSpeechAnalysis.analysis.mostProductiveSpeakers.length
                                                                                    ? selectedMeetingSpeechAnalysis.analysis.mostProductiveSpeakers.join(", ")
                                                                                    : "-"}
                                                                            </div>
                                                                            {selectedMeetingSpeechAnalysis.analysis.mostProductiveSpeakersReason && (
                                                                                <div className="small text-muted mt-2">
                                                                                    {selectedMeetingSpeechAnalysis.analysis.mostProductiveSpeakersReason}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="p-3 border rounded">
                                                                            <div className="fw-bold text-dark">En Az Üretken Konuşmacılar</div>
                                                                            <div className="text-dark mt-1">
                                                                                {Array.isArray(selectedMeetingSpeechAnalysis.analysis.leastProductiveSpeakers) && selectedMeetingSpeechAnalysis.analysis.leastProductiveSpeakers.length
                                                                                    ? selectedMeetingSpeechAnalysis.analysis.leastProductiveSpeakers.join(", ")
                                                                                    : "-"}
                                                                            </div>
                                                                            {selectedMeetingSpeechAnalysis.analysis.leastProductiveSpeakersReason && (
                                                                                <div className="small text-muted mt-2">
                                                                                    {selectedMeetingSpeechAnalysis.analysis.leastProductiveSpeakersReason}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {Array.isArray(selectedMeetingSpeechAnalysis.analysis.speakerPerformances) && selectedMeetingSpeechAnalysis.analysis.speakerPerformances.length > 0 && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Konuşmacı Performansları</h6>
                                                                        <div className="row">
                                                                            {selectedMeetingSpeechAnalysis.analysis.speakerPerformances.map((perf, idx) => (
                                                                                <div className="col-md-6 mb-3" key={idx}>
                                                                                    <div className="p-3 border rounded">
                                                                                        <div className="fw-bold text-dark">{perf?.speaker || "-"}</div>
                                                                                        <div className="text-dark mt-1">{perf?.summary || "-"}</div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {Array.isArray(selectedMeetingSpeechAnalysis.analysis.inefficiencyReasons) && selectedMeetingSpeechAnalysis.analysis.inefficiencyReasons.length > 0 && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Verimsizlik Nedenleri</h6>
                                                                        <div className="row">
                                                                            {selectedMeetingSpeechAnalysis.analysis.inefficiencyReasons.map((item, idx) => (
                                                                                <div className="col-md-6 mb-3" key={idx}>
                                                                                    <div className="p-3 border rounded">
                                                                                        <div className="fw-bold text-dark">
                                                                                            {INEFFICIENCY_TYPE_LABELS[item?.type] || (item?.type || "-").toString()}
                                                                                        </div>
                                                                                        <div className="text-dark mt-1">
                                                                                            {item?.details || "-"}
                                                                                        </div>
                                                                                        <div className="small text-muted mt-2">
                                                                                            Süre: {item?.minutes ?? "-"} dk
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {selectedMeetingSpeechAnalysis?.analysis?.participantRecommendations && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Katılımcı Önerileri</h6>
                                                                        <div className="row">
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Gerekli</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {Array.isArray(selectedMeetingSpeechAnalysis.analysis.participantRecommendations.required) &&
                                                                                            selectedMeetingSpeechAnalysis.analysis.participantRecommendations.required.length
                                                                                            ? selectedMeetingSpeechAnalysis.analysis.participantRecommendations.required.join(", ")
                                                                                            : "-"}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Opsiyonel</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {Array.isArray(selectedMeetingSpeechAnalysis.analysis.participantRecommendations.optional) &&
                                                                                            selectedMeetingSpeechAnalysis.analysis.participantRecommendations.optional.length
                                                                                            ? selectedMeetingSpeechAnalysis.analysis.participantRecommendations.optional.join(", ")
                                                                                            : "-"}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Gerekli Değil</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {Array.isArray(selectedMeetingSpeechAnalysis.analysis.participantRecommendations.notRequired) &&
                                                                                            selectedMeetingSpeechAnalysis.analysis.participantRecommendations.notRequired.length
                                                                                            ? selectedMeetingSpeechAnalysis.analysis.participantRecommendations.notRequired.join(", ")
                                                                                            : "-"}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {selectedMeetingSpeechAnalysis?.analysis?.meetingFormatSuggestion && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Toplantı Formatı Önerisi</h6>
                                                                        <div className="p-3 border rounded">
                                                                            <div className="text-dark">
                                                                                {selectedMeetingSpeechAnalysis.analysis.meetingFormatSuggestion.reason || "-"}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {selectedMeetingSpeechAnalysis?.analysis?.timeOptimization && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Zaman Optimizasyonu</h6>
                                                                        <div className="row">
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Orijinal Süre</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {selectedMeetingSpeechAnalysis.analysis.timeOptimization.originalMinutes ?? "-"} dk
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Tasarruf</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {selectedMeetingSpeechAnalysis.analysis.timeOptimization.savedMinutes ?? "-"} dk
                                                                                        {selectedMeetingSpeechAnalysis.analysis.timeOptimization.savedPercent != null && (
                                                                                            <span> (%{selectedMeetingSpeechAnalysis.analysis.timeOptimization.savedPercent})</span>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-4 mb-3">
                                                                                <div className="p-3 border rounded">
                                                                                    <div className="fw-bold text-dark">Optimize Süre</div>
                                                                                    <div className="text-dark mt-1">
                                                                                        {selectedMeetingSpeechAnalysis.analysis.timeOptimization.optimizedMinutes ?? "-"} dk
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {Array.isArray(selectedMeetingSpeechAnalysis?.analysis?.nextMeetingRecommendations) && selectedMeetingSpeechAnalysis.analysis.nextMeetingRecommendations.length > 0 && (
                                                                    <div className="mt-2">
                                                                        <h6 className="text-dark mb-2">Bir Sonraki Toplantı Önerileri</h6>
                                                                        <div className="p-3 border rounded">
                                                                            <ul className="mb-0">
                                                                                {selectedMeetingSpeechAnalysis.analysis.nextMeetingRecommendations.map((item, idx) => (
                                                                                    <li key={idx}>{item}</li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}

                                                    </div>

                                                    <div id="meetingAIDetailAgenda" className={`tab-pane fade ${activeTab === "meetingAIDetailAgenda" ? "active show" : ""}`}>

                                                        <h5 className="text-info mb-2 mt-5">Gerçekleşen Gündem</h5>
                                                        <div className="mb-15">
                                                            <ul className="mb-0">
                                                                {Array.isArray(selectedMeetingAIDetail.agenda) &&
                                                                    selectedMeetingAIDetail.agenda.map((item, index) => (
                                                                        <li key={index}> <i className="fa fa-circle fs-12" aria-hidden="true"></i> {item}</li>
                                                                    ))}
                                                            </ul>
                                                        </div>

                                                    </div>

                                                    <div id="meetingAIDetailDecisions" className={`tab-pane fade ${activeTab === "meetingAIDetailDecisions" ? "active show" : ""}`}>

                                                        <h5 className="text-info mb-2 mt-5">Alınan Kararlar</h5>
                                                        <div className="mb-15">
                                                            <ul className="mb-0">
                                                                {Array.isArray(selectedMeetingAIDetail.decisions) &&
                                                                    selectedMeetingAIDetail.decisions.map((item, index) => (
                                                                        <li key={index}> <i className="fa fa-circle fs-12" aria-hidden="true"></i> {item}</li>
                                                                    ))}
                                                            </ul>
                                                        </div>

                                                    </div>

                                                    <div id="meetingAIDetailNextAgendaSuggestion" className={`tab-pane fade ${activeTab === "meetingAIDetailNextAgendaSuggestion" ? "active show" : ""}`}>

                                                        <h5 className="text-info mb-2 mt-5">Bir Sonraki Toplantı için Gündem Önerisi</h5>
                                                        <div className="mb-15">
                                                            <ul className="mb-0">
                                                                {Array.isArray(selectedMeetingAIDetail.nextAgendaSuggestion) &&
                                                                    selectedMeetingAIDetail.nextAgendaSuggestion.map((item, index) => (
                                                                        <li key={index}> <i className="fa fa-circle fs-12" aria-hidden="true"></i> {item}</li>
                                                                    ))}
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <Modal show={isDecisionEditOpen} onHide={() => setIsDecisionEditOpen(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Kararı Düzenle</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleDecisionUpdate}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label className="form-label">Başlık</label>
                            <input
                                type="text"
                                className="form-control"
                                value={decisionEditTitle}
                                onChange={(e) => setDecisionEditTitle(e.target.value)}
                                maxLength={120}
                                required
                            />
                        </div>
                        <div>
                            <label className="form-label">Detay</label>
                            <textarea
                                className="form-control"
                                rows={5}
                                value={decisionEditDetails}
                                onChange={(e) => setDecisionEditDetails(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mt-3">
                            <label className="form-label">Termin Tarihi</label>
                            <input
                                type="date"
                                className="form-control"
                                value={decisionEditDeadline}
                                onChange={(e) => setDecisionEditDeadline(e.target.value)}
                            />
                        </div>
                        <div className="form-check mt-3">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="decisionCompleted"
                                checked={decisionEditCompleted}
                                onChange={(e) => setDecisionEditCompleted(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="decisionCompleted">
                                Tamamlandı olarak işaretle
                            </label>
                        </div>
                        <div className="mt-3">
                            <label className="form-label">Görevli Katılımcılar</label>
                            <div className="border rounded p-2" style={{ maxHeight: 180, overflowY: 'auto' }}>
                                {meetingParticipantOptions.length === 0 && (
                                    <div className="small text-muted p-1">Katılımcı bulunamadı.</div>
                                )}
                                {meetingParticipantOptions.map((participant) => (
                                    <div className="form-check" key={`edit-assignee-${participant.id}`}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`edit-assignee-${participant.id}`}
                                            checked={decisionEditUsers.includes(participant.id)}
                                            onChange={() => toggleSelectedUser(participant.id, true)}
                                        />
                                        <label className="form-check-label" htmlFor={`edit-assignee-${participant.id}`}>
                                            {participant.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setIsDecisionEditOpen(false)} disabled={isDecisionSaving}>
                            Vazgeç
                        </Button>
                        <Button type="submit" variant="primary" disabled={isDecisionSaving}>
                            {isDecisionSaving ? 'Kaydediliyor...' : 'Kaydet'}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={isDecisionAddOpen} onHide={() => setIsDecisionAddOpen(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Karar Ekle</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleAddDecision}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label className="form-label">Başlık</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={`Boş bırakılırsa: ${getNextDecisionTitle()}`}
                                value={newDecisionTitle}
                                onChange={(e) => setNewDecisionTitle(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Termin Tarihi</label>
                            <input
                                type="date"
                                className="form-control"
                                value={newDecisionDeadline}
                                onChange={(e) => setNewDecisionDeadline(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="form-label">Karar detayı</label>
                            <textarea
                                className="form-control"
                                rows={4}
                                value={newDecisionDetails}
                                onChange={(e) => setNewDecisionDetails(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mt-3">
                            <label className="form-label">Görevli Katılımcılar</label>
                            <div className="border rounded p-2" style={{ maxHeight: 180, overflowY: 'auto' }}>
                                {meetingParticipantOptions.length === 0 && (
                                    <div className="small text-muted p-1">Katılımcı bulunamadı.</div>
                                )}
                                {meetingParticipantOptions.map((participant) => (
                                    <div className="form-check" key={`add-assignee-${participant.id}`}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`add-assignee-${participant.id}`}
                                            checked={newDecisionUsers.includes(participant.id)}
                                            onChange={() => toggleSelectedUser(participant.id, false)}
                                        />
                                        <label className="form-check-label" htmlFor={`add-assignee-${participant.id}`}>
                                            {participant.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setIsDecisionAddOpen(false)} disabled={isAddingDecision}>
                            Vazgeç
                        </Button>
                        <Button type="submit" variant="primary" disabled={isAddingDecision}>
                            {isAddingDecision ? 'Ekleniyor...' : 'Karar Ekle'}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={isAgendaAddOpen} onHide={() => setIsAgendaAddOpen(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Gündem Ekle</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleAgendaAdd}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label className="form-label">Başlık</label>
                            <input type="text" className="form-control" value={agendaTitle} onChange={(e) => setAgendaTitle(e.target.value)} required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Detay</label>
                            <textarea className="form-control" rows={4} value={agendaDetails} onChange={(e) => setAgendaDetails(e.target.value)} required />
                        </div>
                        <div className="row g-2">
                            <div className="col-6">
                                <label className="form-label">Başlangıç</label>
                                <input type="time" className="form-control" value={agendaStartTime} onChange={(e) => setAgendaStartTime(e.target.value)} required />
                            </div>
                            <div className="col-6">
                                <label className="form-label">Bitiş</label>
                                <input type="time" className="form-control" value={agendaEndTime} onChange={(e) => setAgendaEndTime(e.target.value)} required />
                            </div>
                        </div>
                        <div className="mt-3">
                            <label className="form-label">Görevli Katılımcılar</label>
                            <div className="border rounded p-2" style={{ maxHeight: 180, overflowY: 'auto' }}>
                                {meetingParticipantOptions.map((participant) => (
                                    <div className="form-check" key={`agenda-add-user-${participant.id}`}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`agenda-add-user-${participant.id}`}
                                            checked={agendaUsers.includes(participant.id)}
                                            onChange={() => toggleAgendaUser(participant.id)}
                                        />
                                        <label className="form-check-label" htmlFor={`agenda-add-user-${participant.id}`}>{participant.name}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setIsAgendaAddOpen(false)} disabled={isAgendaAdding}>Vazgeç</Button>
                        <Button type="submit" variant="primary" disabled={isAgendaAdding}>{isAgendaAdding ? 'Ekleniyor...' : 'Kaydet'}</Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={isAgendaEditOpen} onHide={() => setIsAgendaEditOpen(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Gündemi Düzenle</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleAgendaUpdate}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label className="form-label">Başlık</label>
                            <input type="text" className="form-control" value={agendaTitle} onChange={(e) => setAgendaTitle(e.target.value)} required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Detay</label>
                            <textarea className="form-control" rows={4} value={agendaDetails} onChange={(e) => setAgendaDetails(e.target.value)} required />
                        </div>
                        <div className="row g-2">
                            <div className="col-6">
                                <label className="form-label">Başlangıç</label>
                                <input type="time" className="form-control" value={agendaStartTime} onChange={(e) => setAgendaStartTime(e.target.value)} required />
                            </div>
                            <div className="col-6">
                                <label className="form-label">Bitiş</label>
                                <input type="time" className="form-control" value={agendaEndTime} onChange={(e) => setAgendaEndTime(e.target.value)} required />
                            </div>
                        </div>
                        <div className="mt-3">
                            <label className="form-label">Görevli Katılımcılar</label>
                            <div className="border rounded p-2" style={{ maxHeight: 180, overflowY: 'auto' }}>
                                {meetingParticipantOptions.map((participant) => (
                                    <div className="form-check" key={`agenda-edit-user-${participant.id}`}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`agenda-edit-user-${participant.id}`}
                                            checked={agendaUsers.includes(participant.id)}
                                            onChange={() => toggleAgendaUser(participant.id)}
                                        />
                                        <label className="form-check-label" htmlFor={`agenda-edit-user-${participant.id}`}>{participant.name}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setIsAgendaEditOpen(false)} disabled={isAgendaSaving}>Vazgeç</Button>
                        <Button type="submit" variant="primary" disabled={isAgendaSaving}>{isAgendaSaving ? 'Kaydediliyor...' : 'Kaydet'}</Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={isNoteEditOpen} onHide={() => setIsNoteEditOpen(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Notu Düzenle</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleNoteUpdate}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label className="form-label">Başlık</label>
                            <input
                                type="text"
                                className="form-control"
                                value={noteEditTitle}
                                onChange={(e) => setNoteEditTitle(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Detay</label>
                            <textarea
                                className="form-control"
                                rows={5}
                                value={noteEditContext}
                                onChange={(e) => setNoteEditContext(e.target.value)}
                                required
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setIsNoteEditOpen(false)} disabled={isNoteSaving}>
                            Vazgeç
                        </Button>
                        <Button type="submit" variant="primary" disabled={isNoteSaving}>
                            {isNoteSaving ? 'Kaydediliyor...' : 'Kaydet'}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={isAboutEditOpen} onHide={() => setIsAboutEditOpen(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Hakkında Düzenle</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleAboutUpdate}>
                    <Modal.Body>
                        <div>
                            <label className="form-label">Online Toplantı Linki</label>
                            <input
                                type="url"
                                className="form-control"
                                placeholder="https://..."
                                value={aboutOnlineLink}
                                onChange={(e) => setAboutOnlineLink(e.target.value)}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setIsAboutEditOpen(false)} disabled={isAboutSaving}>
                            Vazgeç
                        </Button>
                        <Button type="submit" variant="primary" disabled={isAboutSaving}>
                            {isAboutSaving ? 'Kaydediliyor...' : 'Kaydet'}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </Fragment >

    )
}

export default MeetingDetail
